/* eslint-disable */
import React, { Component } from 'react'
import { ADD_ELOCK_CONNECTION } from '../../../queries'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormHelperText from '@material-ui/core/FormHelperText'
import Select from 'react-select'
import ClientDetails from './ClientDetails'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { Input, InputLabel, Tooltip } from '@material-ui/core'
import PropTypes from 'prop-types'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import getLoginId from '../../../utils/getLoginId'
import normalizeFuelType from '../../../utils/normalizeFuelType'
import { Query, withApollo } from 'react-apollo'
import axios from 'axios'
import FileSaver from 'file-saver'

import moment from 'moment'
import './vehicle.css'
import { phaseOptionsArray } from '../../../utils/phaseOptionsArray'
import { CircularProgress } from '@material-ui/core'
import VehiclePreviewModal from './VehiclePreviewModal'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepButton from '@material-ui/core/StepButton'
import VehicleInfoStep from './VehicleInfoStep'
import InstallationSubmissionStep from './InstallationSubmissionStep'
import TensionerRotationSensorReminder from './TensionerRotationSensorReminder'
import {
  GET_FILE_FORMAT,
  GET_UPLOAD_URL,
  GET_DEVICE_DETAILS,
  GET_CLIENTS,
  GET_VLPN,
  GET_SELECT_DEV_DETAILS,
  GET_SIM_DETAILS,
  GET_ACCESSORY_DETAILS,
  GET_SELECT_PHONE_DETAILS,
  GET_ZMKAM,
  GET_DASHCAM_REGISTRATIONS,
  GET_ALL_ASSIGNED_ROLES,
  ADD_VEHICLE,
  GET_CLIENT_DETAILS_BYID,
  CHECK_ENGINE_NUMBER,
  CHECK_CHASSIS_NUMBER,
  GET_SUBSCRIPTION_BY_PARTNERID,
  GET_MAKE_AND_MODELS_MASTER,
  GET_VEHICLE_MAKES,
  GET_ALL_DG_MAKES,
  GET_DG_MODELS,
  GET_DG_SPECS_FROM_MODEL,
  GET_VEHICLE_TYPE,
  GET_VEHICLE_MODELS,
  GET_VEHICLE_PARAMS,
  GET_VEHICLE_VAHAAN_DETAILS,
  GET_DROPDOWN_DETAILS,
  GET_CUSTOMER_TYPE_AND_CODE,
  GET_ALL_VEHICLES,
  GET_CALIBRATION_DETAILS,
  CONFIRM_VEHICLE_REGISTRATION,
  GET_CLIENT_DETAILS,
  UPDATE_RCS_INVENTORY,
  GET_ALL_TIMEZONES
} from './queries'

  


class VehicleRegistration extends Component {
  constructor(props) {
    super(props)

    // Dynamically generate manufacturing year options
    const currentYear = new Date().getFullYear()
    const manufacturingYearOptions = []

    for (let i = 0; i <= 30; i++) {
      manufacturingYearOptions.push({
        value: currentYear - i,
        label: `${currentYear - i}`
      })
    }

    this.state = {
      isSpeedLimitValid: true,
      isSeatLimitValid: false,
      duplicateVehicle: false,
      timezone_offset: null,
      selectedTimezone: null,
      timezoneList: [],
      isAutoFillEntrySectionOpen: false,
      speedLimit: '',
      seatLimit: null,
      serialNumber: '',
      partnerLoginId: getLoginId(),
      // partnerLoginId: 8,
      isSerialNumberValid: true,
      modelName: '',
      deviceType: '',
      status: 1,
      phoneNumber: '',
      isPhoneNoValid: true,
      simProvider: '',
      simNumber: '',
      vlpn: '',
      isVlpnValid: true,
      vehicleModel: '',
      vehicleMake: '',
      vehicleMakeId: '',
      vehicleModelId: '',
      isVehicleModelValid: true,
      isVehicleMakeValid: true,
      clientName: '',
      isClientNameValid: true,
      vehicleType: '',
      vehicleTypes: [],
      isVehicleTypeValid: true,
      speedSensor: '',
      isSpeedSensorValid: true,
      accessories: null,
      clientsDetails: [],
      deviceDetails: [],
      simDetails: [],
      accessoryDetails: [],
      response: false,
      failure: false,
      schoolBusEnable: false,
      installStatus: true,
      vehicleRegistrationNumberAvailableStatus: false,
      immobilize: false,
      isengineNumberValid: true,
      engineNumber: null,
      chassisNumber: null,
      ischassisNumberValid: true,
      vlpnres: '',
      client: '',
      chassisres: '',
      engineres: '',
      subscriptionId: '',
      mmtc: '',
      noOfDevices: '',
      subscriptionDetails: [],
      idlingSpeed: 3,
      invoiceNumber: '',
      equipmentSerialNumber: null,
      equipmentName: '',
      commissioningDate: {
        date: null,
        unix: moment()
          .unix()
          .toString()
      },
      invoiceDate: {
        date: null,
        unix: moment()
          .unix()
          .toString()
      },
      deviceModelId: '',
      department: '',
      contractorName: '',


      fuelType: '',
      solutionType: '',
      solution_type: [],
      selected_solution_codes: [],
      isDualEngine: false,
      eoff_voltage: null,
      eon_voltage: null,
      hasArm: false,
      isElockConnection: false,
      isIndividualViewOrCombinedView: false,
      engineOnHours: '',
      odometerDistance: '',

      isengineOnHoursValid: true,
      isOdometerDistanceValid: true,
      engineSpecification: '',
      isEngineSpecificationValid: true,
      emissionRateType: '',

      engineSpecificationFromApi: false,
      emissionRateTypeFromApi: false,
      grossVehicleWeightFromApi: false,
      fuelTankCapacityFromApi: false,
      adblueCapacityFromApi: false,
      manufacturingYearFromApi: false,
      fuelTypeFromApi: false,

      makesList: [],
      modelsList: [],
      emissionList: [],
      makeModelsMainList: [],

      grossVehicleWeight: '',
      manufacturingYear: '',
      vehicleSegment: '',
      selectedVTM: '',
      videoTelematicsId: '',
      equipmentTypeClass: '',
      vehicleWheeler: '',
      application: '',
      haulageType: '',
      constructionVehicleType: '',
      tensionerConductorLength: null,
      tensionerRotationSensorDirection: '',
      isRotationSensor: false,
      passengerVehicleType: '',
      transportationVehicleType: '',
      vehicleNickName: '',
      documentUpload: null,
      baselineDataType: '',
      // baselineDataTypeFE: '',
      baselineDataForFE: '',
      baselineDistance: '',
      baselineHours: null,
      fuelTankCapacity: '',
      adblueCapacity: '',
      vehicleCustomizedBodyType: '',
      istachoenabled: false,
      tachoidlerpm: '',
      tachoshifthours: '',
      tachoengineonmin: '',
      tachoengineonmax: '',

      errorMessage: null,
      errorMessageNew: null,
      errorMessageFuelTank: null,
      vtValidationError: null,
      fileNames: '',
      uploadProgress: {}, // Initialize uploadProgress state
      documentUploadNewData: {}, // Map fileName to { solutionType, label }

      equipmentTypeClassOptions: [],
      vehicleWheelerOptions: [],
      // applicationOptions: [],
      haulageTypeOptions: [],
      constructionVehicleTypeOptions: [],
      equipmentTypeClassText: '', // For EVs free text input
      isBaselineDataForFEValid: true, // Assume valid by default

      isBaselineDistanceValid: true,
      isBaselineHoursValid: true,
      isDepartmentValid: true,
      isContractorNameValid: true,
      iseoff_voltageValid: true,
      iseon_voltageValid: true,
      isEquipmentNameValid: true,
      isEquipmentValid: true,
      isInvoiceNoValid: true,
      isAdblueCapacityValid: true,
      isEonVoltageValid: true,
      isEoffVoltageValid: true,

      manufacturingYearOptions,

      segmentOptions: [],
      noOfWheelsOptions: [],
      noOfGearsOptions: [],
      baselineDataTypeFEOptions: [],
      kvaRatingOptions: [],
      dgSetTypeOptions: [],
      phaseOptions: phaseOptionsArray,

      videoTelematicsType: [
        { label: 'LocoNav', value: 'loconav' },
        { label: 'MettaX', value: 'mettax' }
      ],
      dashcamRegistrations: [],
      dashcamRegistrationsLoading: false,
      // Technician dropdowns and createdBy
      assignedTechniciansTaabi: [],
      assignedTechniciansFreelancer: [],
      technicianCategory: null, // 'Taabi' or 'Freelancer'
      selectedTaabiTechnician: null,
      selectedFreelancerTechnician: null,
      technicianName: '',
      createdBy:
        typeof localStorage !== 'undefined'
          ? localStorage.getItem('username') || ''
          : '',
      vtidOptions: [],
      selectedVtid: null,
      selectedSimId: '',
      selectedMemoryCardId: '',
      // states for handling file upload response
      fileName: '',
      bucketName: '',
      publicUploadURL: '',
      downloadUrl: '',
      isUploading: false, // To track upload status
      portedVehicle: '',
      isTestingVehicle: '',
      inputParameter: 16,
      multiplicationFactor: 2,
      kvaRating: '',
      dgSetType: '',
      bhp: '',
      phase: '',
      engineModel: '',
      gensetController: '',

      custCode: '',
      custType: '',
      vehicleData: '',
      rcRegnNo: '',
      rcRegnDt: '',
      rcRegnUpto: '',
      rcPurchaseDt: '',
      rcOwnerSr: '',
      rcOwnerName: '',
      stateCd: '',
      rtoCd: '',
      rcPresentAddress: '',
      rcPermanentAddress: '',
      rcVchCatg: '',
      rcVhClassDesc: '',
      rcChasiNo: '',
      rcEngNo: '',
      rcMakerDesc: '',
      rcMakerModel: '',
      rcBodyTypeDesc: '',
      rcFuelDesc: '',
      rcColor: '',
      rcNormsDesc: '',
      rcFitUpto: '',
      rcNpUpto: '',
      rcNpIssuedBy: '',
      rcTaxUpto: '',
      rcFinancer: '',
      rcInsuranceComp: '',
      rcInsurancePolicyNo: '',
      rcInsuranceUpto: '',
      rcManuMonthYr: '',
      rcUnldWt: null,
      rcGvw: '',
      rcNoCyl: '',
      rcCubicCap: '',
      rcSeatCap: '',
      rcSleeperCap: '',
      rcStandCap: '',
      rcWheelbase: '',
      rcRegisteredAt: '',
      rcStatusAsOn: '',
      rcPuccUpto: '',
      rcPuccNo: '',
      rcStatus: '',
      rcNcrbStatus: '',
      rcBlacklistStatus: '',
      rcPermitNo: '',
      rcPermitIssueDt: '',
      rcPermitValidFrom: '',
      rcPermitValidUpto: '',
      rcPermitType: '',
      rcPermitCode: '',
      rcNocDetails: '',
      rcVhType: '',
      rcVhClass: '',
      rcNocDt: '',
      rcFuelCd: '',
      rcMakerCd: '',
      rcModelCd: '',
      rcNormsCd: '',
      rcSaleAmt: '',
      rcOwnCatgDesc: '',
      rcVhClassDesc: '',
      rcOwnerCdDesc: '',
      rcCurrentaddDistrictcode: '',
      rcNonUse: '',
      rcPassengerTax: '',
      rcGoodsTax: '',
      rcNoOfAxle: null,
      rcApprovalDate: '',
      rcHp: '',
      rcMandalDesc: '',
      rcTalukCd: '',
      noOfWheels: null,
      noOfGears: null,
      previewModalOpen: false,
      previewData: null,
      hasSecondaryTank: null,
      calibrationLoading: false,
      calibrationError: null,
      availableDataTypes: null,
      preferedDataType: null,
      isDualSensor: null,
      hasInSameTank: null,
      calibration_filename: null,
      fuelSensorType: null,
      isSubmitAction: false,
      activeStep: 0
    }

    if (this.props.location.state) {
      this.setState({ clientName: this.props.location.state.clientId })
    } else {
      this.setState({ clientName: '' })
    }
  }

  handleNext = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep + 1
    }))
  }

  handleBack = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep - 1
    }))
  }

  getPreviewData = () => {
    return {
      vehicleNumber: this.state.vehicleNumber
        ? this.state.vehicleNumber
        : this.state.vehicleSegment == 'DG Set'
          ? this.state.vlpn
          : this.state.vehicleData
            ? this.state.vehicleData.rcRegnNo
            : this.state.rcRegnNo,
      solutionType: this.state.solutionType,
      uniqueDeviceId: this.state.serialNumber,
      clientLoginId: parseInt(this.state.clientName, 10),
      videoTelematicsTypeFromVehicleReg:
        this.state.selectedVTM && this.state.selectedVTM.value
          ? this.state.selectedVTM.value
          : null,
      fuelType: (this.state.vehicleData && this.state.vehicleData.rcFuelDesc
        ? this.state.vehicleData.rcFuelDesc
        : this.state.rcFuelDesc)
        ? (this.state.vehicleData && this.state.vehicleData.rcFuelDesc
          ? this.state.vehicleData.rcFuelDesc
          : this.state.rcFuelDesc
        ).toLowerCase()
        : '',
      vehicleMake:
        this.state.vehicleSegment == 'DG Set' ||
          this.state.deviceType == 'obd' ||
          this.state.deviceType == 'OBD'
          ? this.state.vehicleMake
          : this.state.vehicleData
            ? this.state.vehicleData.rcMakerDesc
            : this.state.rcMakerDesc,
      vehicleModel:
        this.state.vehicleSegment == 'DG Set' ||
          this.state.deviceType == 'obd' ||
          this.state.deviceType == 'OBD'
          ? this.state.vehicleModel
          : this.state.vehicleData
            ? this.state.vehicleData.rcMakerModel
            : this.state.rcMakerModel,
      noOfGears: parseInt(this.state.noOfGears),
      gearRatio: this.state.gearRatio,
      isDualEngine: this.state.isDualEngine,
      hasArm: this.state.hasArm,
      isElockConnection: this.state.isElockConnection,
      isRotationSensor: this.state.isRotationSensor,
      solutionType: this.state.solutionType,
      solution_type: this.state.vehicleTypes
    }
  }

  handleOpenPreviewModal = async (isSubmitAction = false) => {
    const previewData = this.getPreviewData()
    console.log('Preview Data:', previewData)
    this.setState({
      calibrationLoading: true,
      calibrationError: null,
      isSubmitAction
    })
    try {
      // 1. Get all vehicles for the client
      const { data: vehiclesData } = await this.props.client.query({
        query: GET_ALL_VEHICLES,
        variables: { clientLoginId: previewData.clientLoginId },
        fetchPolicy: 'network-only'
      })
      // 2. Find entityId for selected vehicleNumber
      const vehicle = vehiclesData.getAllVehicleDetails.find(
        v => v.vehicleNumber === previewData.vehicleNumber
      )
      let hasSecondaryTank = null
      let availableDataTypes = null
      let preferedDataType = null
      let isDualSensor = null
      let hasInSameTank = null
      let calibration_filename = null
      let fuelSensorType = null
      if (vehicle && vehicle.entityId) {
        // 3. Fetch calibration details
        const { data: calibrationData } = await this.props.client.query({
          query: GET_CALIBRATION_DETAILS,
          variables: { entityId: vehicle.entityId },
          fetchPolicy: 'network-only'
        })
        if (calibrationData && calibrationData.getFuelCalibrationDetail) {
          if (
            typeof calibrationData.getFuelCalibrationDetail.hasSecondaryTank !==
            'undefined'
          ) {
            hasSecondaryTank =
              calibrationData.getFuelCalibrationDetail.hasSecondaryTank
          }
          if (
            typeof calibrationData.getFuelCalibrationDetail
              .availableDataTypes !== 'undefined'
          ) {
            availableDataTypes =
              calibrationData.getFuelCalibrationDetail.availableDataTypes
          }
          if (
            typeof calibrationData.getFuelCalibrationDetail.preferedDataType !==
            'undefined'
          ) {
            preferedDataType =
              calibrationData.getFuelCalibrationDetail.preferedDataType
          }
          if (
            typeof calibrationData.getFuelCalibrationDetail.isDualSensor !==
            'undefined'
          ) {
            isDualSensor = calibrationData.getFuelCalibrationDetail.isDualSensor
          }
          if (
            typeof calibrationData.getFuelCalibrationDetail.hasInSameTank !==
            'undefined'
          ) {
            hasInSameTank =
              calibrationData.getFuelCalibrationDetail.hasInSameTank
          }
          if (
            typeof calibrationData.getFuelCalibrationDetail
              .calibration_filename !== 'undefined'
          ) {
            calibration_filename =
              calibrationData.getFuelCalibrationDetail.calibration_filename
          }
          if (
            typeof calibrationData.getFuelCalibrationDetail.fuelSensorType !==
            'undefined'
          ) {
            fuelSensorType =
              calibrationData.getFuelCalibrationDetail.fuelSensorType
          }
        }
      }
      this.setState({
        previewModalOpen: true,
        previewData,
        hasSecondaryTank,
        availableDataTypes,
        preferedDataType,
        isDualSensor,
        hasInSameTank,
        calibration_filename,
        fuelSensorType,
        calibrationLoading: false,
        calibrationError: null,
        isSubmitAction
      })
    } catch (error) {
      this.setState({
        previewModalOpen: true,
        previewData,
        hasSecondaryTank: null,
        availableDataTypes: null,
        preferedDataType: null,
        isDualSensor: null,
        hasInSameTank: null,
        calibration_filename: null,
        fuelSensorType: null,
        calibrationLoading: false,
        calibrationError: error.message || 'Error fetching calibration details',
        isSubmitAction
      })
    }
  }

  handleClosePreviewModal = () => {
    this.setState({ previewModalOpen: false, previewData: null })
  }
  checkBaselineDistanceValidity = () => {
    const { baselineDistance } = this.state
    // Consider an empty string as valid to reset validation state when input is cleared
    const isValid =
      baselineDistance === '' ||
      (/\d+/.test(baselineDistance) && // Check if the input contains at least one digit
      /^\d+$/.test(baselineDistance) && // Check if the input is a positive integer
        parseInt(baselineDistance) > 0 &&
        parseInt(baselineDistance) <= 2000000)

    this.setState({ isBaselineDistanceValid: isValid })
  }

  checkBaselineHoursValidity = () => {
    const { baselineHours } = this.state
    // Consider an empty string as valid to reset validation state when input is cleared
    const isValid =
      baselineHours === '' ||
      (/\d+/.test(baselineHours) && // Check if the input contains at least one digit
      /^\d+$/.test(baselineHours) && // Check if the input is a positive integer
        parseInt(baselineHours) > 0 &&
        parseInt(baselineHours) <= 24)

    this.setState({ isBaselineHoursValid: isValid })
  }

  checkeoff_voltageValidity = () => {
    const regex = new RegExp(/^\d+(\.\d{1,2})?$/) // Allows any number of digits with optional decimal
    this.setState({
      iseoff_voltageValid:
        regex.test(this.state.eoff_voltage) || this.state.eoff_voltage === ''
    })
  }

  checkeon_voltageValidity = () => {
    const regex = new RegExp(/^\d+(\.\d{1,2})?$/) // Same pattern for eon voltage
    this.setState({
      iseon_voltageValid:
        regex.test(this.state.eon_voltage) || this.state.eon_voltage === ''
    })
  }

  checkBaselineDataForFEValidity = () => {
    const { baselineDataForFE } = this.state
    // Consider an empty string as valid to reset validation state when input is cleared
    const isValid =
      baselineDataForFE === '' ||
      (!isNaN(parseFloat(baselineDataForFE)) &&
        parseFloat(baselineDataForFE) >= 0.5 &&
        parseFloat(baselineDataForFE) <= 20 &&
        /^(\d+(\.\d{0,2})?|\.?\d{1,2})$/.test(baselineDataForFE))

    this.setState({ isBaselineDataForFEValid: isValid })
  }

  checkAdblueCapacityValidity = () => {
    const { deviceType, adblueCapacity } = this.state
    let isValid = true
    if (deviceType && deviceType.toLowerCase() === 'obd') {
      isValid = !!adblueCapacity && adblueCapacity.toString().trim() !== ''
    }
    this.setState({ isAdblueCapacityValid: isValid })
    return isValid
  }

  checkDualEngineVoltageValidity = () => {
    const { isDualEngine, eon_voltage, eoff_voltage } = this.state
    let isEonVoltageValid = true
    let isEoffVoltageValid = true
    if (isDualEngine) {
      isEonVoltageValid =
        eon_voltage !== null && eon_voltage !== '' && !isNaN(eon_voltage)
      isEoffVoltageValid =
        eoff_voltage !== null && eoff_voltage !== '' && !isNaN(eoff_voltage)
    }
    this.setState({ isEonVoltageValid, isEoffVoltageValid })
    return isEonVoltageValid && isEoffVoltageValid
  }

  // Compute legacy solutionType string from new solution_type array codes
  computeLegacySolutionType(solutionCodes) {
    // Mapping from internal codes to master solutionType strings
    const codeToMaster = {
      fuel: 'fuel_solution',
      obd: 'obd_solution',
      vt: 'video_telematics',
      obdanalogsolution: 'obd_analog_solution',
      basic_tracking: 'basic_tracking',
      ais_140: 'ais_140',
      asset_tracking: 'Asset Tracking',
      control_tower: 'control_tower',
      testing_vehicle: 'testing_vehicle',

      // New combos + reverse camera 
      'fuel+vt':            'fuel+vt',
      'obd+vt':             'obd+vt',
      'fuel+obd+vt':        'fuel+obd+vt',
      'reverse_camera_screen': 'reverse_camera_screen',
    };

    if (!solutionCodes || solutionCodes.length === 0) {
      return '';
    }

    // Single selection -> pass as is (mapped if necessary)
    if (solutionCodes.length === 1) {
      const code = solutionCodes[0];
      return codeToMaster[code] || code;
    }

    // Multiple selections
    const hasFuel = solutionCodes.includes('fuel_solution');
    const hasObd = solutionCodes.includes('obd_solution');
    const hasVt = solutionCodes.includes('video_telematics');

    // Triple combo – fuel + obd + vt
    if (hasFuel && hasObd && hasVt) {
      return 'fuel+obd+vt';
    }

    // Dual combos with VT
    if (hasFuel && hasVt) {
      return 'fuel+vt';
    }
    if (hasObd && hasVt) {
      return 'obd+vt';
    }

    // Existing legacy combo without VT (fuel + obd)
    if (hasFuel && hasObd) {
      return 'obd_fuel+fuel_solution';
    }

    // Remaining VT cases (already handled above, but kept as safety)
    if (hasVt) {
      if (hasFuel) return 'fuel+vt';
      if (hasObd) return 'obd+vt';
    }

    // Fallback – use the first selected code’s mapping
    const firstCode = solutionCodes[0];
    return codeToMaster[firstCode] || firstCode;
  }



  handleSegmentChange = option => {
    const selectedValue = option ? option.value : ''

    this.setState({ vehicleSegment: selectedValue }, () => {
      console.log('Selected Vehicle Segment: ', selectedValue)
      // this.updateDependentFieldsBasedOnSegment(selectedValue);    ..

      if (selectedValue === 'DG Set') {
        this.updateDGSetData()
      }
    })

    setTimeout(() => {
      if (this.state.vehicleSegment == 'DG Set') {
        this.updateDGSetData()
      }
    }, 500)

    if (this.state.vehicleSegment == 'DG Set') {
      this.setState({
        vehicleRegistrationNumberAvailableStatus: false,
        enteredVehicleRegistrationNumber: ''
      })
      this.flushVahaanValues()
    }
  }

  updateDGSetData() {
    this.setState({ vehicleType: 'DG Set' }, () => {
      this.checkVehicleTypeValidity()
    })

    this.getAllDGMakes()
    if (!this.state.portedVehicle) {
      this.setState({ portedVehicle: true })
    }
    if (!this.state.isTestingVehicle) {
      this.setState({ isTestingVehicle: true })
    }
    if (!this.state.speedSensor) {
      this.setState({ speedSensor: 'GPS SPEED SENSOR' })
    }
    if (!this.state.idlingSpeed) {
      this.setState({ idlingSpeed: 3 })
    }
    if (!this.state.speedLimit) {
      this.setState({ speedLimit: 40 })
    }
    if (!this.state.solutionType) {
      this.setState({ solutionType: 'fuel' })
    }
    if (!this.state.solution_type || this.state.solution_type.length === 0) {
      const defaultCodes = ['fuel'];
      const legacyType = this.computeLegacySolutionType(defaultCodes);
      this.setState({
        solution_type: defaultCodes,
        selected_solution_codes: defaultCodes,
        solutionType: legacyType,
        selected_plan_fuel: '1 Year'
      });
    }
    if (!this.state.fuelType) {
      this.setState({ fuelType: 'Petrol' })
    }
  }

  handleEquipmentTypeClassTextChange = event => {
    this.setState({ equipmentTypeClassText: event.target.value })
  }
  // handleChannelPartnerNameChange = event => {
  //   this.setState({ channelPartnerName: event.target.value })
  // }

  handleInputChangeNew = inputName => event => {
    try {
      const value = event.value
      this.setState({ [inputName]: value }, () => {
        if (inputName === 'vehicleSegment') {
          //  this.updateDependentFieldsBasedOnSegment()
        }
      })
    } catch (error) {
      const value = ''
      this.setState({ [inputName]: value }, () => {
        if (inputName === 'vehicleSegment') {
          //  this.updateDependentFieldsBasedOnSegment()
        }
      })
    }
  }

  handleRemove(fileName) {
    try {
      const { uploadProgress, fileNames } = this.state

      // Remove the file from uploadProgress
      delete uploadProgress[fileName]

      // Remove the fileName from the fileNames array
      const updatedFileNames = fileNames
        .split(',')
        .filter(name => name !== fileName)
        .join(',')

      // Update the state with the modified uploadProgress and fileNames
      this.setState({ uploadProgress, fileNames: updatedFileNames })
    } catch (error) {}
  }

  handleDocumentUploadNewDataChange = (fileName, field, value) => {
    this.setState(prevState => ({
      documentUploadNewData: {
        ...prevState.documentUploadNewData,
        [fileName]: {
          ...prevState.documentUploadNewData[fileName],
          [field]: value
        }
      }
    }))
  }

  handleFileChange = async event => {
    const files = event.target.files // Access all uploaded files
    const maxSize = 30 * 1024 * 1024 // 30MB in bytes
    const maxFiles = 50 // Maximum number of files allowed
    let fileNames = this.state.fileNames || '' // Initialize fileNames to an empty string if undefined
    fileNames = fileNames ? fileNames.split(',') : []
    let uploadProgress = { ...this.state.uploadProgress } // Copy existing upload progress
    const uploadPromises = [] // Array to store upload promises
    let totalSize = 0 // Variable to track total size of files

    this.setState({ errorMessage: null, isUploading: true })

    if (files.length <= 50) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i]

        const fileExtension = file.name.substring(
          file.name.lastIndexOf('.') + 1
        ).toLowerCase()

        const allowedTypes = ['jpeg', 'jpg', 'png', 'pdf']
        if (!allowedTypes.includes(fileExtension)) {
          this.setState({
            errorMessage: `File ${i + 1} type is not supported. Please upload JPEG, JPG, PNG, or PDF files.`,
            isUploading: false
          })
          continue
        }

        if (file.size > maxSize) {
          this.setState({
            errorMessage: `File ${i + 1} size exceeds the limit of 30MB.`
          })
        } else {
          totalSize += file.size

          try {
            const response = await this.props.client.mutate({
              mutation: GET_UPLOAD_URL,
              variables: {
                fileExtension
              }
            })

            if (response.data && response.data.getPublicUploadURL) {
              const {
                publicUploadURL,
                filename
              } = response.data.getPublicUploadURL

              uploadProgress[filename] = 0 // Initialize progress for this filename

              const uploadPromise = axios.put(publicUploadURL, file, {
                headers: {
                  'x-ms-blob-type': 'BlockBlob',
                  'Content-Type': file.type || 'application/octet-stream'
                },
                onUploadProgress: progressEvent => {
                  const progress =
                    (progressEvent.loaded / progressEvent.total) * 100
                  // Update progress for the filename obtained from the response
                  this.setState(prevState => ({
                    uploadProgress: {
                      ...prevState.uploadProgress,
                      [filename]: progress
                    }
                  }))
                }
              })

              uploadPromises.push(uploadPromise)
              fileNames.push(filename) // Store filename in fileNames state
            }
          } catch (error) {
            console.error('Upload error:', error)
          }
        }
      }

      // Update fileNames state after processing all files
      const updatedFileNames = fileNames.slice(0, maxFiles).join(',')
      this.setState({ fileNames: updatedFileNames })

      // Wait for all upload promises to resolve
      try {
        await Promise.all(uploadPromises)
        this.setState({
          isUploading: false
        })
      } catch (error) {
        console.error('Upload error:', error)
        // Handle upload error
      }
    } else {
      this.setState({
        errorMessage: `Maximum 50 files can be selected`,
        isUploading: false
      })
    }
  }

  handleDownload = async fileName => {
    const bucketName = 'aquila-track-uploads'

    const { data } = await this.props.client.query({
      query: GET_FILE_FORMAT,
      variables: {
        bucketname: bucketName,
        filename: fileName
      },
      errorPolicy: 'all'
    })

    const res = await axios({
      url: data.getPublicDownloadURL,
      method: 'GET',
      headers: { Accept: 'application/vnd.ms-excel' },
      responseType: 'blob' // important
    })

    FileSaver.saveAs(new Blob([res.data]), fileName)
  }

  handleInputChange = key => e => {
    if (key == 'custType') {
      console.log(this.state.customerType)
    }
    console.log()
    if (key === 'fuelType') {
      if (!e) {
        this.setState({ [key]: '' })
        return
      }
      this.setState({ [key]: e.value })
    } else if (key === 'portedVehicle') {
      if (!e) {
        this.setState({ [key]: '' })
        return
      }
      this.setState({ [key]: e.value })
    } else if (key === 'isTestingVehicle') {
      if (!e) {
        this.setState({ [key]: '' })
        return
      }
      this.setState({ [key]: e.value })
    } else if (key === 'solutionType') {
      if (!e) {
        this.setState({ [key]: '' })
        return
      }
      this.setState({ [key]: e.value })
    } else if (key === 'solution_type') {
      if (!e) {
        this.setState({ [key]: [], solutionType: '' });
        return;
      }

      // 1. Original codes from the dropdown selection (e.g., ["fuel+vt"])
      const selectedCodes = e.map(opt => opt.code);

      // DEBUG: log what codes the UI passed in
      try {
        console.debug && console.debug('handleInputChange solution_type selectedCodes:', selectedCodes)
      } catch (err) {}

      // 2. Compute legacy solutionType using the original codes
      const legacySolutionType = this.computeLegacySolutionType(selectedCodes);

      // 3. Expand combo codes into individual base codes for solution_type array
      const expanded = [];
      selectedCodes.forEach(code => {
        // If the code contains '+', it's a combo – split and add parts
        if (code.includes('+')) {
          const parts = code.split('+');
          expanded.push(...parts);
        } else {
          expanded.push(code);
        }
      });
      // Deduplicate (in case different combos share a base solution – unrealistic but safe)
      const uniqueExpanded = [...new Set(expanded)];

      // 4. Build plan update objects using the ORIGINAL codes (one plan per combo)
      const planUpdates = {};
      selectedCodes.forEach(code => {
        if (code !== 'reverse_camera_screen') {
          planUpdates[`selected_plan_${code}`] = '1 Year';   // default plan
        }
      });

      this.setState({
        solution_type: selectedCodes,        // ✅ changed from uniqueExpanded to selectedCodes
        selected_solution_codes: selectedCodes, // e.g., ["fuel+tacho_solution"]
        solutionType: legacySolutionType,     // e.g., "fuel+vt"
        ...planUpdates
      });

    } else if (key == 'adblueCapacity' || key == 'fuelTankCapacity') {
      var value = parseFloat(e.target.value)
      if (isNaN(value)) {
        this.setState({ [key]: e.target.value })
        if (key == 'adblueCapacity') {
          this.setState({ errorMessageNew: null })
        } else {
          this.setState({ errorMessageFuelTank: null })
        }
        return false
      }
      if (!Number.isInteger(value)) {
        if (key == 'adblueCapacity') {
          this.setState({ errorMessageNew: 'Decimal values are not allowed.' })
        } else {
          this.setState({
            errorMessageFuelTank: 'Decimal values are not allowed.'
          })
        }
      } else {
        if (key == 'adblueCapacity') {
          this.setState({ errorMessageNew: null })
        } else {
          this.setState({ errorMessageFuelTank: null })
        }
      }

      this.setState({ [key]: e.target.value })
    } else if (
      key == 'department' ||
      key == 'contractorName' ||
      key == 'equipmentName' ||
      key == 'invoiceNumber' ||
      key == 'equipmentSerialNumber' ||
      key == 'isDualEngine' ||
      key == 'hasArm' ||
      key == 'isElockConnection' ||
      key == 'isIndividualViewOrCombinedView' ||
      key == 'duplicateVehicle' ||
      key == 'istachoenabled'
    ) {
      // Check if the input length exceeds 90 characters only if the field is not empty

      if (key == 'department') {
        if (e.target.value.length > 90 && e.target.value.trim() !== '') {
          this.setState({ [key]: e.target.value, isDepartmentValid: false })
        } else {
          this.setState({ [key]: e.target.value, isDepartmentValid: true })
        }
      }

      if (key == 'contractorName') {
        if (e.target.value.length > 90 && e.target.value.trim() !== '') {
          this.setState({ [key]: e.target.value, isContractorNameValid: false })
        } else {
          this.setState({ [key]: e.target.value, isContractorNameValid: true })
        }
      }

      if (key == 'equipmentName') {
        if (e.target.value.length > 90 && e.target.value.trim() !== '') {
          this.setState({ [key]: e.target.value, isEquipmentNameValid: false })
        } else {
          this.setState({ [key]: e.target.value, isEquipmentNameValid: true })
        }
      }

      if (key == 'engineOnHours') {
        if (e.target.value.length > 90 && e.target.value.trim() !== '') {
          this.setState({ [key]: e.target.value, engineOnHours: false })
        } else {
          this.setState({ [key]: e.target.value, engineOnHours: true })
        }
      }

      if (key == 'odometerDistance') {
        if (e.target.value.length > 90 && e.target.value.trim() !== '') {
          this.setState({ [key]: e.target.value, odometerDistance: false })
        } else {
          this.setState({ [key]: e.target.value, odometerDistance: true })
        }
      }

      if (key == 'equipmentSerialNumber') {
        if (e.target.value.length > 90 && e.target.value.trim() !== '') {
          this.setState({ [key]: e.target.value, isEquipmentValid: false })
        } else {
          this.setState({ [key]: e.target.value, isEquipmentValid: true })
        }
      }

      if (key == 'invoiceNumber') {
        if (e.target.value.length > 90 && e.target.value.trim() !== '') {
          this.setState({ [key]: e.target.value, isInvoiceNoValid: false })
        } else {
          this.setState({ [key]: e.target.value, isInvoiceNoValid: true })
        }
      }

      if (key == 'isDualEngine') {
        const isChecked = e.target.checked
        this.setState({ isDualEngine: isChecked }, () => {})
      }
      if (key == 'hasArm') {
        const isChecked = e.target.checked
        this.setState({ hasArm: isChecked }, () => {})
      }

      if (key == 'isElockConnection') {
        const isChecked = e.target.checked
        this.setState({ isElockConnection: isChecked }, () => {})
      }

      if (key == 'duplicateVehicle') {
        const isChecked = e.target.checked
        this.setState({ duplicateVehicle: isChecked }, () => {})
      }

      if (key == 'isIndividualViewOrCombinedView') {
        const isChecked = e.target.checked
        this.setState({ isIndividualViewOrCombinedView: isChecked }, () => { })
      }
      if (key == 'istachoenabled') {
        const isChecked = e.target.checked
        this.setState({ istachoenabled: isChecked }, () => { })
      }
    } else if (
      key === 'phase' ||
      key === 'kvaRating' ||
      key === 'dgSetType' ||
      key === 'selected_plan' ||
      key.startsWith('selected_plan_')
    ) {
      if (!e) {
        this.setState({ [key]: '' })
        return
      }
      this.setState({ [key]: e.value })
    } else {
      if (key === 'rcsSerialNumber') {
        if (!e) {
          this.setState({ [key]: '' })
        } else {
          this.setState({ [key]: e.value })
        }
      } else {
        // const { name, value } = e.target;
        // this.setState({ [name]: value });
        this.setState({
          [key]: e.target.value
        })
      }
    }
  }

  handleDateChange = name => date => {
    let tempDate = this.state[name]
    tempDate.date = date
    tempDate.unix = moment(date)
      .unix()
      .toString()
    this.setState({ [name]: tempDate })
  }

  fetchAllPartnerSubscriptions = async () => {
    const {
      data: subscription,
      error: subscriptionError
    } = await this.props.client.query({
      query: GET_SUBSCRIPTION_BY_PARTNERID,
      variables: {
        partnerId: getLoginId(),
        deviceModelId: this.state.deviceModelId,
        status: [2, 4, 5]
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only'
    })

    const allSubscriptions = subscription.getAllPartnerSubscriptions.map(
      // (lab = subscription.mmtc + ',' + subscription.noOfDevices),
      subscription => ({
        value: subscription.id,
        label: `${subscription.totalSoftwareQty} - ${
          subscription.deviceTrackingCharges
        }`
      })
    )
    if (subscriptionError) {
      this.setState({ subscriptionDetails: [] })
    } else {
      this.setState(
        {
          subscriptionDetails: allSubscriptions
        },
        () => console.log('subscriptionDetails', this.state.subscriptionDetails)
      )
    }
  }

  handleChangeDevice = client => async event => {
    if (event) {
      this.setState({ serialNumber: event.value })
      const response = await client
        .query({
          query: GET_SELECT_DEV_DETAILS,
          variables: { uniqueId: event.value },
          fetchPolicy: 'network-only'
        })
        .catch(error => {
          console.log(error.graphQLErrors[0].message)
        })

      if (response && response.data) {
        const { data } = response
        this.setState(
          {
            modelName: data.devicePartnerAssignDetail.deviceModel.model_name,
            deviceType: data.devicePartnerAssignDetail.deviceModel.devicetype,
            uniqueId: this.state.serialNumber,
            deviceModelId: data.devicePartnerAssignDetail.deviceModel.id
          },
          () => {
            this.fetchAllPartnerSubscriptions()
          }
        )
      }
    } else {
      this.setState({
        modelName: '',
        deviceType: '',
        uniqueId: '',
        serialNumber: '',
        subscriptionDetails: [],
        subscriptionId: ''
      })
    }

    // await this.onCountryFetched(data.allStatesByCountryId)
  }

  handleChangePhoneNumber = client => async event => {
    // this.setState({ phoneNumber: event.target.value })
    if (event) {
      const { data } = await client.query({
        query: GET_SELECT_PHONE_DETAILS,
        variables: { simId: event.value }
      })

      this.setState({
        simProvider: data.simPartnerAssignDetail.serviceProvider.name,
        simNumber: data.simPartnerAssignDetail.sim.simNumber,
        phoneNumber: event.value
      })
    } else {
      this.setState({
        simProvider: '',
        simNumber: '',
        phoneNumber: ''
      })
    }
  }

  handleChangeZM = async event => {
    if (event) {
      this.setState({ zmId: event.value })
    } else {
      this.setState({ zmId: '' })
    }
  }
  handleChangeKAM = async event => {
    if (event) {
      this.setState({ kamId: event.value })
    } else {
      this.setState({ kamId: '' })
    }
  }

  handleVideoTelematicsMenuChange = selectedOption => {
    this.setState({
      selectedVTM: selectedOption,
      selectedVtid: null,
      selectedSimId: null,
      selectedMemoryCardId: null,
      videoTelematicsId: ''
    })
  }
  handleVideoTelematicsIdChange = event => {
    this.setState({ videoTelematicsId: event.target.value })
  }

  handleChangeClient = async event => {
    let cltId = ''
    if (this.props.match.params.loginId === undefined) {
      if (event) {
        cltId = parseInt(event.value, 10)
      }
    } else {
      cltId = parseInt(this.props.match.params.loginId, 10)
      this.props.match.params.loginId = undefined
    }
    this.setState({ clientName: cltId })

    if (cltId !== '') {
      const { data } = await this.props.client.query({
        query: GET_CLIENT_DETAILS_BYID,
        variables: { clientId: cltId },
        errorPolicy: 'all'
        // fetchPolicy: 'network-only'
      })

      const {
        data: device,
        error: deviceError
      } = await this.props.client.query({
        query: GET_DEVICE_DETAILS,
        variables: { clientId: cltId },
        errorPolicy: 'all',
        fetchPolicy: 'network-only'
      })

      const allDevices = device.device.map(device => ({
        value: device.uniqueDeviceId,
        label: device.uniqueDeviceId
      }))
      const {
        data: simDetails,
        error: simError
      } = await this.props.client.query({
        query: GET_SIM_DETAILS,
        variables: { clientId: cltId },
        errorPolicy: 'all',
        fetchPolicy: 'network-only'
      })
      const allSims = simDetails.simDetails.map(sim => ({
        value: sim.simId,
        label: sim.sim.phoneNumber
      }))

      const { data: accessory, error } = await this.props.client.query({
        query: GET_ACCESSORY_DETAILS,
        variables: { clientId: cltId },
        errorPolicy: 'all',
        fetchPolicy: 'network-only'
      })

      const {
        data: customerData,
        error: customerError
      } = await this.props.client.query({
        query: GET_CUSTOMER_TYPE_AND_CODE,
        variables: { clientName: data.clientDetail.clientName },
        errorPolicy: 'all'
      })

      const customerCode =
        customerData.getCustomerTypeAndCode.directCustomerSAPCode ||
        customerData.getCustomerTypeAndCode.channelPartnerSAPCode ||
        ''

      if (accessory.getAllAssignedAccessoryToClient) {
        const allAccessory = accessory.getAllAssignedAccessoryToClient.map(
          accessory1 => ({
            value: accessory1.accessory.uniqueAccessoryId,
            label: accessory1.accessory.uniqueAccessoryId
          })
        )
        if (error) {
          this.setState({ accessoryDetails: [] })
        } else {
          this.setState({
            accessoryDetails: allAccessory
          })
        }
      }

      if (deviceError) {
        this.setState({ deviceDetails: [] })
      } else {
        this.setState({ deviceDetails: allDevices })
      }
      if (simError) {
        this.setState({ simDetails: [] })
      } else {
        this.setState({ simDetails: allSims })
      }

      this.setState({
        client: data.clientDetail.clientName,
        address: data.clientDetail.address,
        id: data.clientDetail.id,
        city: data.clientDetail.city,
        totalRegisteredVehicle: 30,
        totalActiveDevicess: 15,
        totalInactiveDevices: 5,
        showClientDetails: true,
        customerType: customerData.getCustomerTypeAndCode.registrationType,
        customerCode: customerCode
      })
    } else {
      this.setState({
        client: '',
        address: '',
        id: '',
        city: '',
        showClientDetails: false,
        subscriptionDetails: [],
        accessoryDetails: [],
        simDetails: [],
        deviceDetails: [],
        modelName: '',
        deviceType: '',
        uniqueId: '',
        serialNumber: '',
        simProvider: '',
        simNumber: '',
        phoneNumber: '',
        accessories: '',
        subscriptionId: '',
        customerType: '',
        customerCode: ''
      })
    }
  }

  handleChangeMake = async event => {
    this.setState({
      vehicleMake: event ? event.label : null,
      vehicleMakeId: event ? event.value : null,
      kvaRating: '',
      dgSetType: ''
    })
    // console.log('this.state.vehicleSegment',this.state.vehicleSegment, event.value);
    if (event && this.state.vehicleSegment == 'DG Set') {
      const makemodellist = await this.props.client.query({
        query: GET_DG_MODELS,
        variables: { make: event.value },
        fetchPolicy: 'network-only'
      })
      const models = makemodellist.data.getDgModels
      const modelsList =
        models &&
        models.map(model => {
          return {
            id: model,
            model
          }
        })
      this.setState({ modelsList })
      return
    }
    if (event) {
      const makemodellist = await this.props.client.query({
        query: GET_VEHICLE_MODELS,
        variables: { makeId: event.value },
        fetchPolicy: 'network-only'
      })
      this.setState({ modelsList: makemodellist.data.getVehicleModels })
    } else {
      this.setState({ modelsList: [] })
      this.setState({ emissionRateType: '' })
    }
  }

  handleChangeModelNew = async event => {
    let vehicleModel = event ? event.label : null
    let vehicleModelId = event ? event.value : null

    this.setState({
      vehicleModel: vehicleModel,
      vehicleModelId: vehicleModelId
    })
  }

  handleChangeModel = async event => {
    this.setState({
      vehicleModel: event ? event.label : null,
      vehicleModelId: event ? event.value : null,
      emissionRateType: '',
      grossVehicleWeight: '',
      fuelTankCapacity: '',
      adblueCapacity: '',
      manufacturingYear: '',
      fuelType: '',
      engineSpecification: '',
      engineSpecificationFromApi: false,
      emissionRateTypeFromApi: false,
      grossVehicleWeightFromApi: false,
      fuelTankCapacityFromApi: false,
      adblueCapacityFromApi: false,
      manufacturingYearFromApi: false,
      fuelTypeFromApi: false
    })

    if (event && this.state.vehicleSegment == 'DG Set') {
      const make = this.state.vehicleMake
      const dgSpecsResponse = await this.props.client.query({
        query: GET_DG_SPECS_FROM_MODEL,
        variables: { make: make, model: event.value },
        fetchPolicy: 'network-only'
      })
      const dgSpecs = dgSpecsResponse.data.getDgspecsFromModel

      const kvaRatingOptions =
        dgSpecs &&
        dgSpecs.map(row => {
          return {
            value: row.kvaRating,
            label: row.kvaRating
          }
        })
      if (kvaRatingOptions.length === 1) {
        this.setState({ kvaRating: kvaRatingOptions[0].value })
      }
      const dgSetTypeOptions =
        dgSpecs &&
        dgSpecs.map(row => {
          return {
            value: row.dgSetType,
            label: row.dgSetType
          }
        })
      if (dgSetTypeOptions.length === 1) {
        this.setState({ dgSetType: dgSetTypeOptions[0].value })
      }
      this.setState({ kvaRatingOptions, dgSetTypeOptions })
      return
    }
    if (event) {
      try {
        var makemodellistDetails = await this.props.client.query({
          query: GET_VEHICLE_PARAMS,
          variables: { modelId: event.value },
          fetchPolicy: 'network-only'
        })

        console.log(makemodellistDetails.data, 'heyyy')

        if (makemodellistDetails && makemodellistDetails.data) {
          if (makemodellistDetails.data.getVehicleParameters.length > 0) {
            let fuelType =
              makemodellistDetails.data.getVehicleParameters[0]['fuel_type']
            if (fuelType === 'Diesel' || fuelType === 'diesel') {
              fuelType = 'Diesel'
            }

            if (fuelType === 'Petrol' || fuelType === 'petrol') {
              fuelType = 'Petrol'
            }
            this.setState({
              emissionRateType:
                makemodellistDetails.data.getVehicleParameters[0][
                  'emission_type'
                ],
              grossVehicleWeight:
                makemodellistDetails.data.getVehicleParameters[0][
                  'gross_vehicle_weight'
                ],
              fuelTankCapacity:
                makemodellistDetails.data.getVehicleParameters[0][
                  'fuel_capacity'
                ],
              adblueCapacity:
                makemodellistDetails.data.getVehicleParameters[0][
                  'adblue_capacity'
                ],
              manufacturingYear:
                makemodellistDetails.data.getVehicleParameters[0][
                  'manufacturing_year'
                ],
              fuelType: fuelType,
              engineSpecification:
                makemodellistDetails.data.getVehicleParameters[0][
                  'engine_specification'
                ]
            })

            // Set the corresponding flags to true only if data is not null
            if (
              makemodellistDetails.data.getVehicleParameters[0]['emission_type']
            ) {
              this.setState({ emissionRateTypeFromApi: true })
            }
            if (
              makemodellistDetails.data.getVehicleParameters[0][
                'gross_vehicle_weight'
              ]
            ) {
              this.setState({ grossVehicleWeightFromApi: true })
            }
            if (
              makemodellistDetails.data.getVehicleParameters[0]['fuel_capacity']
            ) {
              this.setState({ fuelTankCapacityFromApi: true })
            }
            if (
              makemodellistDetails.data.getVehicleParameters[0][
                'adblue_capacity'
              ]
            ) {
              this.setState({ adblueCapacityFromApi: true })
            }
            if (
              makemodellistDetails.data.getVehicleParameters[0][
                'manufacturing_year'
              ]
            ) {
              this.setState({ manufacturingYearFromApi: true })
            }
            if (
              makemodellistDetails.data.getVehicleParameters[0]['fuel_type']
            ) {
              this.setState({ fuelTypeFromApi: true })
            }
            if (
              makemodellistDetails.data.getVehicleParameters[0][
                'engine_specification'
              ]
            ) {
              this.setState({ engineSpecificationFromApi: true })
            }
          }
        }
      } catch (error) {
        this.setState({
          emissionRateType: '',
          grossVehicleWeight: '',
          fuelTankCapacity: '',
          adblueCapacity: '',
          manufacturingYear: '',
          fuelType: '',
          engineSpecification: '',
          engineSpecificationFromApi: false,
          emissionRateTypeFromApi: false,
          grossVehicleWeightFromApi: false,
          fuelTankCapacityFromApi: false,
          adblueCapacityFromApi: false,
          manufacturingYearFromApi: false,
          fuelTypeFromApi: false
        })
      }
    }
  }

  handleChangeType = event => {
    const selectedVehicleType = event ? event.value : null
    this.setState({ vehicleType: selectedVehicleType }, () => {
      this.checkVehicleTypeValidity()
    })
  }

  handleEmissionType = event => {
    this.setState({ emissionRateType: event ? event.value : null })
  }
  handleChangeSpeedSensor = event => {
    if (event) {
      this.setState({ speedSensor: event.value })
    } else {
      this.setState({ speedSensor: '' })
    }
  }

  handleChangeTimezone = selectedOption => {
    this.setState({
      selectedTimezone: selectedOption,
      timezone_offset: selectedOption ? selectedOption.value : null
    })
  }
  handleChangeIdlingSpeed = event => {
    try {
      if (event) {
        this.setState({ idlingSpeed: event.value })
      } else {
        this.setState({ idlingSpeed: 3 })
      }
    } catch (error) {
      this.setState({ idlingSpeed: 3 })
    }
  }
  handleChangeAccessories = event => {
    if (!event) {
      this.setState({ accessories: '' })
    } else {
      this.setState({ accessories: event.value })
    }
  }

  handleChangeInputParameter = event => {
    const value = event.target.value
    this.setState({ inputParameter: value ? parseFloat(value) : null })
  }

  handleChangeMultiplicationFactor = event => {
    const value = event.target.value
    this.setState({ multiplicationFactor: value ? parseFloat(value) : null })
  }

  handleChangeSubscription = event => {
    if (!event) {
      this.setState({ subscriptionId: '' })
    } else {
      this.setState({ subscriptionId: event.value })
    }
  }
  checkSerialNumberValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z\s]+$/)
    this.setState({
      isSerialNumberValid: this.state.serialNumber !== ''
    })
  }
  checkAddressValidity = () => {
    const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,}$/)
    this.setState({
      isAddressValid:
        regex.test(this.state.address) && this.state.address === ''
    })
  }
  checkVehicleModelValidity = () => {
    const regex = /^[a-zA-Z][a-zA-Z0-9 -]*$/
    this.setState({
      isVehicleModelValid:
        regex.test(this.state.vehicleModel) &&
        this.state.vehicleModel !== '' &&
        this.state.vehicleModel.length > 1 &&
        this.state.vehicleModel.length < 21
    })
  }

  checkVehicleMakeValidity = () => {
    if (this.state.vehicleMake !== '') {
      const regex = /^[a-zA-Z][a-zA-Z0-9 -]*$/
      this.setState({
        isVehicleMakeValid:
          regex.test(this.state.vehicleMake) &&
          this.state.vehicleMake !== '' &&
          this.state.vehicleMake.length > 1 &&
          this.state.vehicleMake.length < 70
      })
    }
  }

  checkItemValidity = key => e => {
    if (e.target.value !== '') {
      const regex = /^[a-zA-Z0-9 .-@,]*$/
      switch (key) {
        case 'engineOnHours':
          this.setState({
            isengineOnHoursValid:
              regex.test(e.target.value) && e.target.value !== ''
          })
          break
        case 'odometerDistance':
          this.setState({
            isOdometerDistanceValid:
              regex.test(e.target.value) && e.target.value !== ''
          })
          break

        case 'engineSpecification':
          this.setState({
            isEngineSpecificationValid: e.target.value !== ''
          })
          break
        default:
          break
      }
    }
  }

  checkSpeedLimitValidity = () => {
    const regex = new RegExp(/^[1-9][0-9]{0,2}$/)
    this.setState({
      isSpeedLimitValid:
        regex.test(this.state.speedLimit) &&
        this.state.speedLimit !== '' &&
        this.state.speedLimit <= 160 &&
        this.state.speedLimit >= 10
    })
  }
  checkSeatLimitValidity = () => {
    const regex = new RegExp(/^[1-9][0-9]$/)
    this.setState({
      isSeatLimitValid:
        regex.test(this.state.seatLimit) && this.state.seatLimit !== ''
    })
  }
  checkVlpnValidity = client => async event => {
    const { data } = await client.query({
      query: GET_VLPN,
      variables: { vlpn: this.state.vlpn }
    })
    this.setState({
      isVlpnValid:
        this.state.vlpn !== '' &&
        data.checkVehicleNumber === 'AVAILABLE' &&
        this.state.vlpn.length > 4 &&
        this.state.vlpn.length < 33
    })
    if (data.checkVehicleNumber !== 'AVAILABLE') {
      this.setState({ vlpnres: 'Vehicle Number Already Exist!' })
    } else if (this.state.vlpn !== '') {
      if (this.state.vlpn.length < 5 || this.state.vlpn.length > 32) {
        this.setState({ vlpnres: 'Max character length is between 5 to 32' })
      } else {
        this.setState({ vlpnres: 'Invalid Vehicle Number' })
      }
    }
  }
  checkVlpnUnique = client => async event => {
    const { data } = await client.query({
      query: GET_VLPN,
      variables: { vlpn: this.state.vlpn }
    })
    this.setState({
      isVlpnValid: data.checkVehicleNumber === 'AVAILABLE'
    })
    // await this.onCountryFetched(data.allStatesByCountryId)
  }
  checkClientNameValidity = () => {
    this.setState({
      isClientNameValid: this.state.clientName !== ''
    })
  }

  checkVehicleTypeValidity = () => {
    const isSchoolBus = this.state.vehicleType === 'School Bus'
    this.setState({
      isVehicleTypeValid: this.state.vehicleType !== '',
      isSeatLimitValid: isSchoolBus // Update isSeatLimitValid based on selected vehicle type
    })
  }

  checkSpeedSensorValidity = () => {
    this.setState({
      isSpeedSensorValid: this.state.speedSensor !== ''
    })
  }

  handleSubmit = (client, mutationInput) => async event => {
    console.log('mutationInput', mutationInput)
    if (this.state.seatLimit === '') {
      this.setState({ seatLimit: null })
    }
    event.preventDefault()
    let commissioningDate =
      this.state.commissioningDate.date === null
        ? null
        : parseInt(this.state.commissioningDate.unix)

    let invoiceDate =
      this.state.invoiceDate.date === null
        ? null
        : parseInt(this.state.invoiceDate.unix)

    let formattedFileNames = ''

    try {
      formattedFileNames = this.state.fileNames
        .split(',')
        .map(fileName => fileName.trim())
        .join(',') // Split file names by comma, trim whitespace, and join back with commas
    } catch (error) { }
    let statusOnboard = 'failure'

    const { data, errors } = await client.mutate({
      mutation: ADD_VEHICLE,
      variables: {
        vehicleNumber: this.state.vehicleNickName
          ? this.state.vehicleNickName
          : this.state.vehicleSegment == 'DG Set'
            ? this.state.vlpn
            : this.state.vehicleData
              ? this.state.vehicleData.rcRegnNo
              : this.state.rcRegnNo,
        engineNumber: this.state.vehicleData
          ? this.state.vehicleData.rcEngNo
          : this.state.rcEngNo,
        chassisNumber: this.state.vehicleData
          ? this.state.vehicleData.rcChasiNo
          : this.state.rcChasiNo,
        // vehicleType: (this.state.vehicleSegment == 'DG Set' ? this.state.vehicleSegment : this.state.vehicleData ? this.state.vehicleData.rcVhType : this.state.rcVhType || '') == 'T' ? "Truck" : this.state.vehicleSegment == 'DG Set' ? this.state.vehicleSegment : this.state.vehicleData ? this.state.vehicleData.rcVhType : this.state.rcVhType || 'N/A',
        vehicleType: (() => {
          const {
            vehicleSegment,
            transportationVehicleType,
            constructionVehicleType,
            passengerVehicleType,
            vehicleData,
            rcVhType
          } = this.state

          if (vehicleSegment === 'Transportation')
            return transportationVehicleType || 'N/A'
          if (vehicleSegment === 'Construction')
            return constructionVehicleType || 'N/A'
          if (vehicleSegment === 'Passenger')
            return passengerVehicleType || 'N/A'

          let vehicleType = (vehicleData && vehicleData.rcVhType) || rcVhType
          vehicleType = vehicleType === 'T' ? 'Truck' : vehicleType || 'N/A'
          return vehicleSegment || vehicleType
        })(),

        vehicleMake:
          this.state.vehicleSegment == 'DG Set' ||
            this.state.deviceType == 'obd' ||
            this.state.deviceType == 'OBD'
            ? this.state.vehicleMake
            : this.state.vehicleData
              ? this.state.vehicleData.rcMakerDesc
              : this.state.rcMakerDesc,
        // averageMileage: Int,
        vehicleModel:
          this.state.vehicleSegment == 'DG Set' ||
            this.state.deviceType == 'obd' ||
            this.state.deviceType == 'OBD'
            ? this.state.vehicleModel
            : this.state.vehicleData
              ? this.state.vehicleData.rcMakerModel
              : this.state.rcMakerModel,
        baselineDataType: this.state.baselineDataType,
        // baselineDataHour:Float,
        // baselineDataForFELPH: Float,
        noOfGears: parseInt(this.state.noOfGears),
        gearRatio: this.state.gearRatio,

        vehicleRegistrationNumber:
          this.state.vehicleData && this.state.vehicleData.rcRegnNo
            ? this.state.vehicleData.rcRegnNo
            : this.state.rcRegnNo,
        registrationDate:
          this.state.vehicleData && this.state.vehicleData.rcRegnDt
            ? this.state.vehicleData.rcRegnDt
            : this.state.rcRegnDt,
        registrationValidUpto:
          this.state.vehicleData && this.state.vehicleData.rcRegnUpto
            ? this.state.vehicleData.rcRegnUpto
            : this.state.rcRegnUpto,
        stateCode:
          this.state.vehicleData && this.state.vehicleData.stateCd
            ? this.state.vehicleData.stateCd
            : this.state.stateCd,
        rtoCode:
          this.state.vehicleData && this.state.vehicleData.rtoCd
            ? this.state.vehicleData.rtoCd
            : this.state.rtoCd,
        vehicleCategoryCode:
          this.state.vehicleData && this.state.vehicleData.rcVchCatg
            ? this.state.vehicleData.rcVchCatg
            : this.state.rcVchCatg,
        // vehicleCategoryDescription: this.state.vehicleData ? this.state.vehicleData.rcVchCatgDesc : this.state.rcVchCatgDesc,
        vehicleClassDescription:
          this.state.vehicleData && this.state.vehicleData.rcVhClassDesc
            ? this.state.vehicleData.rcVhClassDesc
            : this.state.rcVhClassDesc,
        makerDescription:
          this.state.vehicleData && this.state.vehicleData.rcMakerDesc
            ? this.state.vehicleData.rcMakerDesc
            : this.state.rcMakerDesc,
        makerModel:
          this.state.vehicleData && this.state.vehicleData.rcMakerModel
            ? this.state.vehicleData.rcMakerModel
            : this.state.rcMakerModel,
        bodyTypeDescription:
          this.state.vehicleData && this.state.vehicleData.rcBodyTypeDesc
            ? this.state.vehicleData.rcBodyTypeDesc
            : this.state.rcBodyTypeDesc,
        // fuelType: ((this.state.vehicleData && this.state.vehicleData.rcFuelDesc) ? this.state.vehicleData.rcFuelDesc : this.state.rcFuelDesc).toLowerCase(),
        fuelType: (this.state.vehicleData && this.state.vehicleData.rcFuelDesc
          ? this.state.vehicleData.rcFuelDesc
          : this.state.rcFuelDesc)
          ? (this.state.vehicleData && this.state.vehicleData.rcFuelDesc
            ? this.state.vehicleData.rcFuelDesc
            : this.state.rcFuelDesc
          ).toLowerCase()
          : '',
        emissionNormsDescription:
          this.state.vehicleData && this.state.vehicleData.rcNormsDesc
            ? this.state.vehicleData.rcNormsDesc
            : this.state.rcNormsDesc,
        fitmentUpto:
          this.state.vehicleData && this.state.vehicleData.rcFitUpto
            ? this.state.vehicleData.rcFitUpto
            : this.state.rcFitUpto,
        nationalPermitUpto:
          this.state.vehicleData && this.state.vehicleData.rcNpUpto
            ? this.state.vehicleData.rcNpUpto
            : this.state.rcNpUpto,
        taxUpto:
          this.state.vehicleData && this.state.vehicleData.rcTaxUpto
            ? this.state.vehicleData.rcTaxUpto
            : this.state.rcTaxUpto,
        insurerName:
          this.state.vehicleData && this.state.vehicleData.rcInsuranceComp
            ? this.state.vehicleData.rcInsuranceComp
            : this.state.rcInsuranceComp,
        insuranceUpto:
          this.state.vehicleData && this.state.vehicleData.rcInsuranceUpto
            ? this.state.vehicleData.rcInsuranceUpto
            : this.state.rcInsuranceUpto,
        manufacturingMonthYear:
          this.state.vehicleData && this.state.vehicleData.rcManuMonthYr
            ? this.state.vehicleData.rcManuMonthYr
            : this.state.rcManuMonthYr,
        unladenWeight:
          this.state.vehicleData && this.state.vehicleData.rcUnldWt
            ? this.state.vehicleData.rcUnldWt
            : this.state.rcUnldWt
              ? this.state.rcUnldWt
              : null,
        registeredAt:
          this.state.vehicleData && this.state.vehicleData.rcRegisteredAt
            ? this.state.vehicleData.rcRegisteredAt
            : this.state.rcRegisteredAt,
        puccUpto:
          this.state.vehicleData && this.state.vehicleData.rcPuccUpto
            ? this.state.vehicleData.rcPuccUpto
            : this.state.rcPuccUpto,
        permitNumber:
          this.state.vehicleData && this.state.vehicleData.rcPermitNo
            ? this.state.vehicleData.rcPermitNo
            : this.state.rcPermitNo,
        permitIssueDate:
          this.state.vehicleData && this.state.vehicleData.rcPermitIssueDt
            ? this.state.vehicleData.rcPermitIssueDt
            : this.state.rcPermitIssueDt,
        permitValidFrom:
          this.state.vehicleData && this.state.vehicleData.rcPermitValidFrom
            ? this.state.vehicleData.rcPermitValidFrom
            : this.state.rcPermitValidFrom,
        permitValidUpto:
          this.state.vehicleData && this.state.vehicleData.rcPermitValidUpto
            ? this.state.vehicleData.rcPermitValidUpto
            : this.state.rcPermitValidUpto,
        permitType:
          this.state.vehicleData && this.state.vehicleData.rcPermitType
            ? this.state.vehicleData.rcPermitType
            : this.state.rcPermitType,
        permitCode:
          this.state.vehicleData && this.state.vehicleData.rcPermitCode
            ? this.state.vehicleData.rcPermitCode
            : this.state.rcPermitCode,
        numberOfAxles: parseInt(
          this.state.vehicleData && this.state.vehicleData.rcNoOfAxle
            ? this.state.vehicleData.rcNoOfAxle
            : this.state.rcNoOfAxle
              ? this.state.rcNoOfAxle
              : null
        ),
        fuelCode:
          this.state.vehicleData && this.state.vehicleData.rcFuelCd
            ? this.state.vehicleData.rcFuelCd
            : this.state.rcFuelCd,
        vehicleClass:
          this.state.vehicleData && this.state.vehicleData.rcVhClass
            ? this.state.vehicleData.rcVhClass
            : this.state.rcVhClass,

        clientLoginId: parseInt(this.state.clientName, 10),
        uniqueDeviceId: this.state.serialNumber,
        simId: parseInt(this.state.phoneNumber, 10),
        speedSensorType: this.state.speedSensor,
        speedLimit: parseInt(this.state.speedLimit, 10),
        // vehicleType: this.state.vehicleType,
        // vehicleModel: this.state.vehicleModel,

        vehicleModelId:
          this.state.vehicleSegment == 'DG Set' ||
            this.state.deviceType == 'obd' ||
            this.state.deviceType == 'OBD'
            ? this.state.vehicleModelId
            : null,
        vehicleMakeId:
          this.state.vehicleSegment == 'DG Set' ||
            this.state.deviceType == 'obd' ||
            this.state.deviceType == 'OBD'
            ? this.state.vehicleMakeId
            : null,

        uniqueAccessoryId: this.state.accessories,
        vehicleCapacity: parseInt(this.state.seatLimit, 10),
        isActivated: this.state.installStatus,
        isVehicleRegistrationNumberAvailable: this.state
          .vehicleRegistrationNumberAvailableStatus,
        status: this.state.status,
        // engineNumber: this.state.engineNumber,
        // chassisNumber: this.state.vehicleData ? this.state.vehicleData.rcChasiNo : this.state.rcChasiNo,
        accountType: 'PA',
        partnerSubscriptionId: this.state.subscriptionId || 50,
        equipmentSerialNumber: this.state.equipmentSerialNumber,
        commissioningDate: commissioningDate,
        invoiceDate: invoiceDate,
        rcsSerialNumber: this.state.rcsSerialNumber,
        idlingSpeed: this.state.idlingSpeed,
        equipmentName: this.state.equipmentName,
        invoiceNumber: this.state.invoiceNumber,
        department: this.state.department,
        contractorName: this.state.contractorName,

        solutionType: this.state.solutionType,
        solution_type: this.state.solution_type,
        isDualEngine: this.state.isDualEngine,
        eon_voltage: parseFloat(this.state.eon_voltage),
        eoff_voltage: parseFloat(this.state.eoff_voltage),
        hasArm: this.state.hasArm,
        isElockConnection: this.state.isElockConnection,
        isIndividualViewOrCombinedView: this.state
          .isIndividualViewOrCombinedView,
        engineOnHours: this.state.engineOnHours,
        odometerDistance: this.state.odometerDistance,
        duplicateVehicle: this.state.duplicateVehicle,
        //torquePower: this.state.torquePower,
        engineSpecification: this.state.engineSpecification,
        emissionRateType: this.state.emissionRateType,
        istachoenabled: this.state.istachoenabled,
        tachoidlerpm: this.state.tachoidlerpm ? parseInt(this.state.tachoidlerpm) : null,
        tachoengineonmin:
          this.state.tachoengineonmin !== '' && this.state.tachoengineonmin !== null
            ? parseInt(this.state.tachoengineonmin, 10)
            : null,
        tachoengineonmax:
          this.state.tachoengineonmax !== '' && this.state.tachoengineonmax !== null
            ? parseInt(this.state.tachoengineonmax, 10)
            : null,
        tachoshifthours: this.state.tachoshifthours ? parseInt(this.state.tachoshifthours) : null,

        grossVehicleWeight: parseFloat(
          this.state.vehicleData && this.state.vehicleData.rcGvw
        )
          ? this.state.vehicleData.rcGvw
          : this.state.rcGvw
            ? this.state.rcGvw
            : null,
        // manufacturingYear: parseInt(this.state.manufacturingYear),
        vehicleSegment: this.state.vehicleSegment,
        equipmentTypeClass: this.state.equipmentTypeClass,
        vehicleWheeler: this.state.vehicleWheeler,

        application:
          this.state.vehicleSegment === 'Transportation'
            ? this.state.selectedApplication
            : '',
        transportationVehicleType:
          this.state.vehicleSegment === 'Transportation'
            ? this.state.transportationVehicleType
            : '',
        haulageType:
          this.state.vehicleSegment === 'Transportation'
            ? this.state.haulageType
            : '',
        constructionVehicleType:
          this.state.vehicleSegment === 'Construction'
            ? this.state.constructionVehicleType
            : '',
        passengerVehicleType:
          this.state.vehicleSegment === 'Passenger'
            ? this.state.passengerVehicleType
            : '',
        vehicleNickName: this.state.vehicleNickName,
        documentUpload: formattedFileNames,
        documentUploadNew: this.state.fileNames ? this.state.fileNames.split(',').filter(Boolean).map(fileName => ({
          fileName: fileName.trim(),
          ...(this.state.documentUploadNewData[fileName.trim()] || { solutionType: '', label: '' })
        })) : [],
        baselineDataForFE: parseFloat(this.state.baselineDataForFE),

        baselineDistance: parseInt(this.state.baselineDistance),
        fuelTankCapacity: this.state.fuelTankCapacity
          ? this.state.fuelTankCapacity.toString()
          : null,
        adblueCapacity: this.state.adblueCapacity
          ? this.state.adblueCapacity.toString()
          : null,
        immobilize: this.state.immobilize ? this.state.immobilize : false,
        portedVehicle: this.state.portedVehicle == 'Yes' ? true : false,
        isTestingVehicle:
          this.state.isTestingVehicle == 'Testing' ? true : false,

        kvaRating: this.state.kvaRating,
        dgSetType: this.state.dgSetType,
        bhp: this.state.bhp,
        phase: this.state.phase,
        engineModel: this.state.engineModel,
        gensetController: this.state.gensetController,
        videoTelematicsType:
          this.state.selectedVTM && this.state.selectedVTM.value
            ? this.state.selectedVTM.value
            : null,
        videoTelematicsId:
          this.state.selectedVTM &&
            this.state.selectedVTM.value &&
            this.state.videoTelematicsId
            ? this.state.videoTelematicsId
            : null,
        inputParameter: this.state.inputParameter
          ? this.state.inputParameter
          : null,
        multiplicationFactor: this.state.multiplicationFactor
          ? this.state.multiplicationFactor
          : null,
        technicianName: this.state.technicianName || null,
        createdBy: this.state.createdBy || null,
        clientName: this.state.client,
        custCode: this.state.customerCode,
        custType: this.state.customerType,
        noOfWheels: this.state.noOfWheels ? parseInt(this.state.noOfWheels) : null,
        baselineHours: parseInt(this.state.baselineHours),
        vehicleCustomizedBodyType: this.state.vehicleCustomizedBodyType,
        tensionerConductorLength: this.state.tensionerConductorLength,
        tensionerRotationSensorDirection:
          this.state.tensionerRotationSensorDirection || '',
        isRotationSensor: this.state.isRotationSensor,
        timezone_offset: this.state.timezone_offset || null
      },
      errorPolicy: 'all'
    })
    if (data) {
      statusOnboard = 'success'
      console.log('ifffff')

      try {
        await client.mutate({
          mutation: ADD_ELOCK_CONNECTION,
          variables: {
            uniqueId: this.state.serialNumber,
            status: this.state.isElockConnection ? 1 : 0,
            deviceType: this.state.deviceType
          }
        })
      } catch (error) {
        console.log('Error adding elock connection', error)
      }

      await client.resetStore()
      this.setState({ response: data.addVehicleDetail })
      // After successful onboarding, if addVehicleDetail returned `true`, and reverse camera + screen
      // was selected and an RCS serial number was provided, mark that serial as assigned in inventory.
      try {
        if (
          data.addVehicleDetail === true &&
          Array.isArray(this.state.solution_type) &&
          this.state.solution_type.includes('reverse_camera_screen') &&
          this.state.rcsSerialNumber
        ) {
          // Use the same uniqueDeviceId used to register the vehicle (this.state.serialNumber)
          await client.mutate({
            mutation: UPDATE_RCS_INVENTORY,
            variables: {
              rcsSerialNumber: this.state.rcsSerialNumber,
              input: {
                status: 'assigned',
                unique_id: this.state.serialNumber
              }
            }
          })
        } else {
          console.log('Skipping RCS inventory update - conditions not met', {
            addVehicleDetail: data.addVehicleDetail,
            solution_type: this.state.solution_type,
            rcsSerialNumber: this.state.rcsSerialNumber,
            uniqueDeviceId: this.state.serialNumber
          })
        }
      } catch (err) {
        console.error('Failed to update RCS inventory after onboarding', err)
        // don't block onboarding flow on inventory update failure; surface a snackbar
        this.props.openSnackbar('Vehicle registered but failed to mark RCS as assigned')
      }
      this.props.openSnackbar('Registered Successfully')
      this.props.history.push('/home/VehcileDashboard/Dashboard')

      // Dynamically generate manufacturing year options
      const currentYear = new Date().getFullYear()
      const manufacturingYearOptions = []

      for (let i = 0; i <= 30; i++) {
        manufacturingYearOptions.push({
          value: currentYear - i,
          label: `${currentYear - i}`
        })
      }

      this.setState({
        isSpeedLimitValid: true,
        duplicateVehicle: false,
        isSeatLimitValid: false,
        speedLimit: '',
        seatLimit: null,
        serialNumber: '',
        partnerLoginId: getLoginId(),
        // partnerLoginId: 8,
        isSerialNumberValid: true,
        modelName: '',
        deviceType: '',
        status: 1,
        phoneNumber: '',
        isPhoneNoValid: true,
        simProvider: '',
        simNumber: '',
        vlpn: '',
        isVlpnValid: true,
        vehicleModel: '',
        vehicleMake: '',
        isVehicleModelValid: true,
        isVehicleMakeValid: true,
        clientName: '',
        isClientNameValid: true,
        vehicleType: '',
        isVehicleTypeValid: true,
        speedSensor: '',
        isSpeedSensorValid: true,
        accessories: null,
        clientsDetails: [],
        deviceDetails: [],
        simDetails: [],
        accessoryDetails: [],
        response: false,
        failure: false,
        schoolBusEnable: false,
        installStatus: true,
        vehicleRegistrationNumberAvailableStatus: false,
        isengineNumberValid: true,
        engineNumber: null,
        chassisNumber: null,
        ischassisNumberValid: true,
        vlpnres: '',
        client: '',
        chassisres: '',
        engineres: '',
        subscriptionId: '',
        mmtc: '',
        noOfDevices: '',
        subscriptionDetails: [],
        idlingSpeed: 3,
        invoiceNumber: '',
        equipmentSerialNumber: null,
        equipmentName: '',
        commissioningDate: {
          date: null,
          unix: moment()
            .unix()
            .toString()
        },
        invoiceDate: {
          date: null,
          unix: moment()
            .unix()
            .toString()
        },
        deviceModelId: '',
        department: '',
        contractorName: '',


        fuelType: '',
        solutionType: '',
        solution_type: [],
        selected_solution_codes: [],
        isDualEngine: false,
        eoff_voltage: null,
        eon_voltage: null,
        // reset technician selections
        technicianCategory: null,
        selectedTaabiTechnician: null,
        selectedFreelancerTechnician: null,
        technicianName: '',
        hasArm: false,
        isElockConnection: false,
        isIndividualViewOrCombinedView: false,
        engineOnHours: '',
        odometerDistance: '',

        isengineOnHoursValid: true,
        isOdometerDistanceValid: true,
        engineSpecification: '',
        isEngineSpecificationValid: true,
        emissionRateType: '',
        istachoenabled: false,
        tachoidlerpm: '',
        tachoshifthours: '',

        engineSpecificationFromApi: false,
        emissionRateTypeFromApi: false,
        grossVehicleWeightFromApi: false,
        fuelTankCapacityFromApi: false,
        adblueCapacityFromApi: false,
        manufacturingYearFromApi: false,
        fuelTypeFromApi: false,

        makesList: [],
        modelsList: [],
        emissionList: [],
        makeModelsMainList: [],

        grossVehicleWeight: '',
        manufacturingYear: '',
        vehicleSegment: '',
        selectedVTM: '',
        videoTelematicsId: '',
        equipmentTypeClass: '',
        vehicleWheeler: '',
        application: '',
        haulageType: '',
        constructionVehicleType: '',
        passengerVehicleType: '',
        transportationVehicleType: '',
        vehicleNickName: '',
        documentUpload: null,
        baselineDataType: '',
        // baselineDataTypeFE: '',
        baselineDataForFE: '',
        baselineHours: null,
        baselineDistance: '',
        fuelTankCapacity: '',
        adblueCapacity: '',

        errorMessage: null,
        errorMessageNew: null,
        errorMessageFuelTank: null,
        fileNames: '',
        uploadProgress: {}, // Initialize uploadProgress state

        equipmentTypeClassOptions: [],
        vehicleWheelerOptions: [],
        // applicationOptions: [],
        haulageTypeOptions: [],
        constructionVehicleTypeOptions: [],
        equipmentTypeClassText: '', // For EVs free text input
        isBaselineDataForFEValid: true, // Assume valid by default

        manufacturingYearOptions,

        segmentOptions: [],
        noOfWheelsOptions: [],
        noOfGearsOptions: [],
        baselineDataTypeFEOptions: [],
        phaseOptions: phaseOptionsArray,
        videoTelematicsType: [
          { label: 'LocoNav', value: 'loconav' },
          { label: 'MettaX', value: 'mettax' }
        ],
        inputParameter: 16,
        multiplicationFactor: 2,
        // states for handling file upload response
        fileName: '',
        bucketName: '',
        publicUploadURL: '',
        downloadUrl: '',
        isUploading: false, // To track upload status

        showClientDetails: false,
        address: '',
        id: '',
        city: '',
        totalRegisteredVehicle: '',
        totalActiveDevicess: '',
        totalInactiveDevices: '',

        sparePartName: '',
        // zmId: '',
        // kamId: '',
        // channelPartnerName: '',
        // throughChannelPartner: false,
        portedVehicle: null,
        isTestingVehicle: null,

        kvaRating: '',
        dgSetType: '',
        bhp: '',
        phase: '',
        engineModel: '',
        gensetController: '',

        custCode: '',
        custType: '',
        vehicleData: '',
        rcRegnNo: '',
        rcRegnDt: '',
        rcRegnUpto: '',
        rcPurchaseDt: '',
        rcOwnerSr: '',
        rcOwnerName: '',
        stateCd: '',
        rtoCd: '',
        rcPresentAddress: '',
        rcPermanentAddress: '',
        rcVchCatg: '',
        rcVhClassDesc: '',
        rcChasiNo: '',
        rcEngNo: '',
        rcMakerDesc: '',
        rcMakerModel: '',
        rcBodyTypeDesc: '',
        rcFuelDesc: '',
        rcColor: '',
        rcNormsDesc: '',
        rcFitUpto: '',
        rcNpUpto: '',
        rcNpIssuedBy: '',
        rcTaxUpto: '',
        rcFinancer: '',
        rcInsuranceComp: '',
        rcInsurancePolicyNo: '',
        rcInsuranceUpto: '',
        rcManuMonthYr: '',
        // rcUnldWt: null,
        rcUnldWt: '',
        rcGvw: '',
        rcNoCyl: '',
        rcCubicCap: '',
        rcSeatCap: '',
        rcSleeperCap: '',
        rcStandCap: '',
        rcWheelbase: '',
        rcRegisteredAt: '',
        rcStatusAsOn: '',
        rcPuccUpto: '',
        rcPuccNo: '',
        rcStatus: '',
        rcNcrbStatus: '',
        rcBlacklistStatus: '',
        rcPermitNo: '',
        rcPermitIssueDt: '',
        rcPermitValidFrom: '',
        rcPermitValidUpto: '',
        rcPermitType: '',
        rcPermitCode: '',
        rcNocDetails: '',
        rcVhType: '',
        rcVhClass: '',
        rcNocDt: '',
        rcFuelCd: '',
        rcMakerCd: '',
        rcModelCd: '',
        rcNormsCd: '',
        rcSaleAmt: '',
        rcOwnCatgDesc: '',
        rcVhClassDesc: '',
        rcOwnerCdDesc: '',
        rcCurrentaddDistrictcode: '',
        rcNonUse: '',
        rcPassengerTax: '',
        rcGoodsTax: '',
        rcNoOfAxle: null,
        rcApprovalDate: '',
        rcHp: '',
        rcMandalDesc: '',
        rcTalukCd: '',
        noOfWheels: null,
        noOfGears: null,
        vehicleCustomizedBodyType: '',
        customerCode: '',
        customerType: ''
      })
    } else {
      statusOnboard = 'failure'
      console.log('elseeeeeee')
      this.setState({ failure: true })
      // this.props.openSnackbar(errors[0].message)

      const submitErrorMessage = errors[0].message

      if (
        submitErrorMessage &&
        submitErrorMessage.includes('Vehicle number is already registered')
      ) {
        this.props.openSnackbar('Vehicle number is already registered.')
      } else {
        this.props.openSnackbar(submitErrorMessage)
      }
    }
    console.log('outtttt')
    // Use mutationInput directly if provided
    if (mutationInput) {
      // Add status to mutationInput
      const mutationInputWithStatusOnboard = {
        ...mutationInput,
        statusOnboard: statusOnboard
      }
      await client.mutate({
        mutation: CONFIRM_VEHICLE_REGISTRATION,
        variables: { input: mutationInputWithStatusOnboard }
      })
    }
  }
  getAllClients = async () => {
    const clientsDetails = await this.props.client.query({
      query: GET_CLIENTS,
      variables: {
        partnerLoginId: parseInt(this.state.partnerLoginId, 10),
        status: parseInt(this.state.status, 10)
      },
      fetchPolicy: 'network-only'
    })
    const allClients = clientsDetails.data.clientsDetails.map(client => ({
      value: client.loginId,
      label: client.clientName
    }))
    this.setState({ clientsDetails: allClients })
  }
  getZMKAMDetails = async () => {
    const zmkamDetails = await this.props.client.query({
      query: GET_ZMKAM,
      variables: {
        roleName: ['Zonal Manager(ZM)', 'Key Account Manager(KAM)']
      },
      fetchPolicy: 'network-only'
    })
    const zmDetails = zmkamDetails.data.getAdminUserDetailsByRole
      .filter(user => user.role === 'Zonal Manager(ZM)')
      .map(user => ({
        value: user.id,
        label: user.username
      }))
    const kamDetails = zmkamDetails.data.getAdminUserDetailsByRole
      .filter(user => user.role === 'Key Account Manager(KAM)')
      .map(user => ({
        value: user.id,
        label: user.username
      }))
    this.setState({ zmDetails: zmDetails, kamDetails: kamDetails })
  }

  getAllAssignedRoles = async () => {
    try {
      const { data } = await this.props.client.query({
        query: GET_ALL_ASSIGNED_ROLES,
        fetchPolicy: 'network-only'
      })
      if (data && data.getAllAssignedRoles) {
        const taabiList = data.getAllAssignedRoles
          .filter(u => u.role === 'Technician - Taabi Personal')
          .map(u => ({
            label: u.username || u.email || u.uuid,
            value: u.username || u.uuid
          }))

        const freelancerList = data.getAllAssignedRoles
          .filter(u => u.role === 'Technician - Freelancer')
          .map(u => ({
            label: u.mobile_number || u.username || u.uuid,
            value: u.mobile_number || u.uuid
          }))

        this.setState({
          assignedTechniciansTaabi: taabiList,
          assignedTechniciansFreelancer: freelancerList
        })
      }
    } catch (error) {
      // swallow or log error
      console.error('Error fetching assigned roles', error)
    }
  }

  handleTechnicianCategoryChange = option => {
    // option is an object from react-select
    const category = option && option.value ? option.value : null
    this.setState({
      technicianCategory: category,
      // clear selections when switching
      selectedTaabiTechnician: null,
      selectedFreelancerTechnician: null,
      technicianName: ''
    })
  }

  handleTaabiSelectChange = option => {
    this.setState({
      selectedTaabiTechnician: option,
      technicianName: option ? option.value : ''
    })
  }

  handleFreelancerSelectChange = option => {
    this.setState({
      selectedFreelancerTechnician: option,
      technicianName: option ? option.value : ''
    })
  }

  getDashcamRegistrations = async () => {
    this.setState({ dashcamRegistrationsLoading: true })

    try {
      const { data } = await this.props.client.query({
        query: GET_DASHCAM_REGISTRATIONS,
        fetchPolicy: 'network-only'
      })

      if (data.getDashcamRegistrations.success) {
        const registrations = data.getDashcamRegistrations.data.filter(
          registrations => registrations.status === 'available'
        )

        const vtidOptions = registrations.map(item => ({
          value: item.vtid,
          label: item.vtid,
          simid: item.simid,
          memorycardid: item.memorycardid
        }))

        this.setState({
          dashcamRegistrations: registrations,
          vtidOptions,
          dashcamRegistrationsLoading: false
        })
      } else {
        this.setState({ dashcamRegistrationsLoading: false })
      }
    } catch (error) {
      console.error('Error fetching dashcam registrations:', error)
      this.setState({ dashcamRegistrationsLoading: false })
    }
  }

  handleVtidChange = selectedOption => {
    if (selectedOption && selectedOption.value) {
      this.setState({
        selectedVtid: selectedOption,
        selectedSimId: selectedOption.simid,
        selectedMemoryCardId: selectedOption.memorycardid,
        videoTelematicsId: selectedOption.value
      })
    } else {
      this.setState({
        selectedVtid: null,
        selectedSimId: null,
        selectedMemoryCardId: null,
        videoTelematicsId: null
      })
    }
  }

  getMakeAndModels = async () => {
    const makemodellist = await this.props.client.query({
      query: GET_VEHICLE_MAKES,
      variables: {},
      fetchPolicy: 'network-only'
    })

    // console.log('makemodellist',makemodellist.data.getVehicleMakes);
    this.setState({ makesList: makemodellist.data.getVehicleMakes })
  }

  getAllDGMakes = async () => {
    const responce = await this.props.client.query({
      query: GET_ALL_DG_MAKES,
      variables: {},
      fetchPolicy: 'network-only'
    })
    const makes = responce.data.getDgMakes
    console.log('makes', makes)
    const makesList =
      makes &&
      makes.map(make => {
        return {
          make,
          id: make
        }
      })
    console.log('makesList', makesList)
    this.setState({ makesList: makesList })
  }
  getVehicleType = async () => {
    const { data } = await this.props.client.query({
      query: GET_VEHICLE_TYPE,
      variables: {},
      fetchPolicy: 'network-only'
    })
    const vehicleTypes = data.getAllVehicleType.map(item => item.vehicleType)
    this.setState({ vehicleTypes })
  }
  getTimezones = async () => {
    try {
      const { data } = await this.props.client.query({
        query: GET_ALL_TIMEZONES
      })
      if (data && data.getAllTimezones) {
        this.setState({ timezoneList: data.getAllTimezones })
      }
    } catch (error) {
      console.error('Error fetching timezones:', error)
    }
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked }, () => {
      console.log(this.state.installStatus, 'kk')
    })
  }

  flushVahaanValues = async () => {
    if (this.state.vehicleSegment == 'DG Set') {
      this.setState({
        loading: false,
        vehicleData: null,
        rcRegnNo: '',
        rcRegnDt: '',
        rcRegnUpto: '',
        rcPurchaseDt: '',
        rcOwnerSr: '',
        rcOwnerName: '',
        stateCd: '',
        rtoCd: '',
        rcPresentAddress: '',
        rcPermanentAddress: '',
        rcVchCatg: '',
        rcVhClassDesc: '',
        rcChasiNo: '',
        rcEngNo: '',
        rcMakerDesc: '',
        rcMakerModel: '',
        rcBodyTypeDesc: '',
        rcFuelDesc: '',
        rcColor: '',
        rcNormsDesc: '',
        rcFitUpto: '',
        rcNpUpto: '',
        rcNpIssuedBy: '',
        rcTaxUpto: '',
        rcFinancer: '',
        rcInsuranceComp: '',
        rcInsurancePolicyNo: '',
        rcInsuranceUpto: '',
        rcManuMonthYr: '',
        rcUnldWt: '',
        rcGvw: '',
        rcNoCyl: '',
        rcCubicCap: '',
        rcSeatCap: '',
        rcSleeperCap: '',
        rcStandCap: '',
        rcWheelbase: '',
        rcRegisteredAt: '',
        rcStatusAsOn: '',
        rcPuccUpto: '',
        rcPuccNo: '',
        rcStatus: '',
        rcNcrbStatus: '',
        rcBlacklistStatus: '',
        rcPermitNo: '',
        rcPermitIssueDt: '',
        rcPermitValidFrom: '',
        rcPermitValidUpto: '',
        rcPermitType: '',
        rcPermitCode: '',
        rcNocDetails: '',
        rcVhType: '',
        rcVhClass: '',
        rcNocDt: '',
        rcFuelCd: '',
        rcMakerCd: '',
        rcModelCd: '',
        rcNormsCd: '',
        rcSaleAmt: '',
        rcOwnCatgDesc: '',
        rcVhClassDesc: '',
        rcOwnerCdDesc: '',
        rcCurrentaddDistrictcode: '',
        rcNonUse: '',
        rcPassengerTax: '',
        rcGoodsTax: '',
        rcNoOfAxle: '',
        rcApprovalDate: '',
        rcHp: '',
        rcMandalDesc: '',
        rcTalukCd: ''
      })
    }
  }

  handleVehicleRegistrationNumberAvailableChange = name => event => {
    const enteredVehicleRegistrationNumber = null

    this.setState({ [name]: event.target.checked }, () => {
      if (this.state.vehicleRegistrationNumberAvailableStatus) {
        console.log('Vehicle Registration Number Available')
      } else {
        console.log('Vehicle Registration Number Unavailable')
        this.setState({
          loading: false,
          vehicleData: null,
          rcRegnNo: '',
          rcRegnDt: '',
          rcRegnUpto: '',
          rcPurchaseDt: '',
          rcOwnerSr: '',
          rcOwnerName: '',
          stateCd: '',
          rtoCd: '',
          rcPresentAddress: '',
          rcPermanentAddress: '',
          rcVchCatg: '',
          rcVhClassDesc: '',
          rcChasiNo: '',
          rcEngNo: '',
          rcMakerDesc: '',
          rcMakerModel: '',
          rcBodyTypeDesc: '',
          rcFuelDesc: '',
          rcColor: '',
          rcNormsDesc: '',
          rcFitUpto: '',
          rcNpUpto: '',
          rcNpIssuedBy: '',
          rcTaxUpto: '',
          rcFinancer: '',
          rcInsuranceComp: '',
          rcInsurancePolicyNo: '',
          rcInsuranceUpto: '',
          rcManuMonthYr: '',
          rcUnldWt: '',
          rcGvw: '',
          rcNoCyl: '',
          rcCubicCap: '',
          rcSeatCap: '',
          rcSleeperCap: '',
          rcStandCap: '',
          rcWheelbase: '',
          rcRegisteredAt: '',
          rcStatusAsOn: '',
          rcPuccUpto: '',
          rcPuccNo: '',
          rcStatus: '',
          rcNcrbStatus: '',
          rcBlacklistStatus: '',
          rcPermitNo: '',
          rcPermitIssueDt: '',
          rcPermitValidFrom: '',
          rcPermitValidUpto: '',
          rcPermitType: '',
          rcPermitCode: '',
          rcNocDetails: '',
          rcVhType: '',
          rcVhClass: '',
          rcNocDt: '',
          rcFuelCd: '',
          rcMakerCd: '',
          rcModelCd: '',
          rcNormsCd: '',
          rcSaleAmt: '',
          rcOwnCatgDesc: '',
          rcVhClassDesc: '',
          rcOwnerCdDesc: '',
          rcCurrentaddDistrictcode: '',
          rcNonUse: '',
          rcPassengerTax: '',
          rcGoodsTax: '',
          rcNoOfAxle: '',
          rcApprovalDate: '',
          rcHp: '',
          rcMandalDesc: '',
          rcTalukCd: ''
        })
      }
    })
  }

  getDataByVehicleNumber = async () => {
    const { enteredVehicleRegistrationNumber } = this.state
    this.setState({ vehicleData: null, vlpnres: '', loading: false })

    if (
      !enteredVehicleRegistrationNumber ||
      enteredVehicleRegistrationNumber.length < 5 ||
      enteredVehicleRegistrationNumber.length > 32
    ) {
      this.setState({
        vlpnres:
          'Vehicle Registration Number must be between 5 to 32 characters.'
      })
      return
    }

    try {

      this.setState({
        loading: true
      })

      const response = await this.props.client.query({
        query: GET_VEHICLE_VAHAAN_DETAILS,
        variables: { vehicleNumber: enteredVehicleRegistrationNumber }
      })

      if (
        response.data &&
        response.data.getVehicleVahaanDetails &&
        response.data.getVehicleVahaanDetails.length > 0
      ) {
        const vahaanDetails = response.data.getVehicleVahaanDetails[0]
        // Vahan fuel descriptions are inconsistent (e.g. "DIESEL/HYBRID"); map
        // them to the fuel-type option values so the dropdown auto-selects.
        const vehicleData = {
          ...vahaanDetails,
          rcFuelDesc: normalizeFuelType(vahaanDetails.rcFuelDesc)
        }
        this.setState({ vehicleData: vehicleData })
        console.log('Fetched vehicle details:', vehicleData)
      } else {
        console.log('No vehicle details found.')
        {
          this.setState({
            vlpnres:
              'Data not available currently for the entered Vehicle Number. Please check the Vehicle Number and try again after some time.'
          })
        }
      }
    } catch (error) {
      console.error('Error fetching vehicle details:', error)
      {
        this.setState({
          vlpnres:
            'Error occurred while fetching vehicle details. Please try again after some time.'
        })
      }
    } finally {
      this.setState({ loading: false })
    }

    if (this.state.vlpnres) {
      this.setState({
        rcRegnNo: '',
        rcRegnDt: '',
        rcRegnUpto: '',
        rcPurchaseDt: '',
        rcOwnerSr: '',
        rcOwnerName: '',
        stateCd: '',
        rtoCd: '',
        rcPresentAddress: '',
        rcPermanentAddress: '',
        rcVchCatg: '',
        rcVhClassDesc: '',
        rcChasiNo: '',
        rcEngNo: '',
        rcMakerDesc: '',
        rcMakerModel: '',
        rcBodyTypeDesc: '',
        rcFuelDesc: '',
        rcColor: '',
        rcNormsDesc: '',
        rcFitUpto: '',
        rcNpUpto: '',
        rcNpIssuedBy: '',
        rcTaxUpto: '',
        rcFinancer: '',
        rcInsuranceComp: '',
        rcInsurancePolicyNo: '',
        rcInsuranceUpto: '',
        rcManuMonthYr: '',
        rcUnldWt: '',
        rcGvw: '',
        rcNoCyl: '',
        rcCubicCap: '',
        rcSeatCap: '',
        rcSleeperCap: '',
        rcStandCap: '',
        rcWheelbase: '',
        rcRegisteredAt: '',
        rcStatusAsOn: '',
        rcPuccUpto: '',
        rcPuccNo: '',
        rcStatus: '',
        rcNcrbStatus: '',
        rcBlacklistStatus: '',
        rcPermitNo: '',
        rcPermitIssueDt: '',
        rcPermitValidFrom: '',
        rcPermitValidUpto: '',
        rcPermitType: '',
        rcPermitCode: '',
        rcNocDetails: '',
        rcVhType: '',
        rcVhClass: '',
        rcNocDt: '',
        rcFuelCd: '',
        rcMakerCd: '',
        rcModelCd: '',
        rcNormsCd: '',
        rcSaleAmt: '',
        rcOwnCatgDesc: '',
        rcVhClassDesc: '',
        rcOwnerCdDesc: '',
        rcCurrentaddDistrictcode: '',
        rcNonUse: '',
        rcPassengerTax: '',
        rcGoodsTax: '',
        rcNoOfAxle: '',
        rcApprovalDate: '',
        rcHp: '',
        rcMandalDesc: '',
        rcTalukCd: ''
      })
    }



    {

    }
  }


  handleImmobilizeChange = name => event => {
    this.setState({ [name]: event.target.checked }, () => {
      console.log(this.state.immobilize, 'kk')
    })
  }
  checkEngineNumber = async () => {
    if (this.state.engineNumber !== '' && this.state.engineNumber !== null) {
      const { data } = await this.props.client.query({
        query: CHECK_ENGINE_NUMBER,
        variables: { engineNumber: this.state.engineNumber }
      })

      this.setState({
        isengineNumberValid:
          data.checkEngineNumber === 'AVAILABLE' &&
          this.state.engineNumber.length > 1 &&
          this.state.engineNumber.length < 41
      })
      if (data.checkEngineNumber !== 'AVAILABLE') {
        this.setState({ engineres: 'Engine Number Already Exist!' })
      } else if (
        (this.state.engineNumber !== '' && this.state.engineNumber !== null) ||
        this.state.engineNumber.length < 1 ||
        this.state.engineNumber.length > 40
      ) {
        this.setState({
          engineres: 'Engine Number should be between 2-40 characters'
        })
      }
    }
    if (this.state.engineNumber === '') {
      this.setState({ engineNumber: null })
    }
  }
  checkChassisNumber = async () => {
    if (this.state.chassisNumber !== '' && this.state.chassisNumber !== null) {
      const { data } = await this.props.client.query({
        query: CHECK_CHASSIS_NUMBER,
        variables: { chassisNumber: this.state.chassisNumber }
      })

      this.setState({
        ischassisNumberValid:
          data.checkChassisNumber === 'AVAILABLE' &&
          this.state.chassisNumber.length > 1 &&
          this.state.chassisNumber.length < 41
      })
      if (data.checkChassisNumber !== 'AVAILABLE') {
        this.setState({ chassisres: 'Chassis Number Already Exist!' })
      } else if (
        (this.state.chassisNumber !== '' &&
          this.state.chassisNumber !== null) ||
        this.state.chassisNumber.length < 1 ||
        this.state.chassisNumber.length > 40
      ) {
        this.setState({
          chassisres: 'Chassis Number should be between 2-40 characters'
        })
      }
    }
    if (this.state.chassisNumber === '') {
      this.setState({ chassisNumber: null })
    }
  }
  isNumericalArray = array => {
    return array.every(item => !isNaN(item))
  }

  sortNumericalArray = array => {
    return array.sort((a, b) => parseInt(a) - parseInt(b))
  }
  fetchDropdownDetails = async () => {
    try {
      const response = await this.props.client.query({
        query: GET_DROPDOWN_DETAILS
      })

      console.log('Raw response:', response)

      const dropdownData = JSON.parse(response.data.getDropDownDetail)

      console.log('Parsed dropdown data:', dropdownData)

      const dropdownValues = {}

      Object.keys(dropdownData).forEach(key => {
        if (Array.isArray(dropdownData[key])) {
          dropdownValues[key] = dropdownData[key].filter(
            option => option !== null
          )
        }
        if (this.isNumericalArray(dropdownValues[key])) {
          dropdownValues[key] = this.sortNumericalArray(dropdownValues[key])
        }
      })

      this.setState({
        ...dropdownValues,
        selectedApplication: ''
      })
    } catch (error) {
      console.error('Error fetching dropdown details:', error)
    }
  }
  fetchCustomerTypeAndCode = async clientName => {
    try {
      const response = await this.props.client.query({
        query: GET_CUSTOMER_TYPE_AND_CODE,
        variables: { clientName }
      })

      console.log('Raw response:', response)

      const customerData = response.data.getCustomerTypeAndCode

      console.log('Parsed customer data:', customerData)

      const customerValues = {
        id: customerData.id,
        clientName: customerData.clientName,
        registrationType: customerData.registrationType,
        directCustomerSAPCode: customerData.directCustomerSAPCode,
        channelPartnerSAPCode: customerData.channelPartnerSAPCode
      }

      this.setState({
        ...customerValues
      })
    } catch (error) {
      console.error('Error fetching customer type and code:', error)
    }
  }

  componentDidMount() {
    this.getTimezones()
    this.getDashcamRegistrations()
    this.getMakeAndModels()
    this.getVehicleType()
    this.getAllAssignedRoles()
    // this.getDGSpecifications()
    // this.getAllDGMakes();
    this.fetchDropdownDetails()
    if (this.props.match.params.loginId === undefined) {
      this.getAllClients()
    } else {
      this.getAllClients()
      this.handleChangeClient()
    }
    this.getZMKAMDetails()
  }

  getStep0MissingFields() {
    const {
      isClientNameValid,
      showClientDetails,
      clientName,
      vehicleSegment,
      vehicleData,
      rcRegnNo,
      rcMakerDesc,
      rcMakerModel,
      transportationVehicleType,
      selectedApplication,
      haulageType,
      constructionVehicleType,
      passengerVehicleType,
      vehicleType,
      tensionerConductorLength,
      tensionerRotationSensorDirection,
      vehicleMakeId,
      vehicleModelId,
      fuelTankCapacity,
      kvaRating,
      dgSetType
    } = this.state

    const missing = []
    if (!isClientNameValid || !showClientDetails || !clientName)
      missing.push('Customer Name')
    if (!vehicleSegment) {
      missing.push('Vehicle Segment')
      return missing
    }

    if (vehicleSegment !== 'DG Set') {
      const regNo = (vehicleData && vehicleData.rcRegnNo) || rcRegnNo
      const maker = (vehicleData && vehicleData.rcMakerDesc) || rcMakerDesc
      const model = (vehicleData && vehicleData.rcMakerModel) || rcMakerModel

      if (!regNo) missing.push('Vehicle Number')
      if (!maker) missing.push('Maker')
      if (!model) missing.push('Model')

      if (vehicleSegment === 'Transportation') {
        if (!selectedApplication) missing.push('Application')
        if (!haulageType) missing.push('Haulage Type')
        if (!transportationVehicleType)
          missing.push('Transportation Vehicle Type')
      }
      if (vehicleSegment === 'Construction') {
        if (!constructionVehicleType) missing.push('Construction Type')
        if (
          constructionVehicleType === 'Tensioner' &&
          !tensionerConductorLength
        )
          missing.push('Conductor Length')
        if (
          constructionVehicleType === 'Tensioner' &&
          !tensionerRotationSensorDirection
        )
          missing.push('Rotation Sensor Direction')
      }
      if (
        vehicleSegment === 'Passenger Vehicles' ||
        vehicleSegment === 'Passenger'
      ) {
        if (!passengerVehicleType) missing.push('Passenger Vehicle Type')
      }
    } else {
      // DG Set
      if (!vehicleType) missing.push('Asset Type')
      if (!vehicleMakeId) missing.push('Make')
      if (!vehicleModelId) missing.push('Model')
      if (!kvaRating) missing.push('KVA Rating')
      if (!dgSetType) missing.push('DG Set Type')
    }

    return missing
  }

  isStep0Invalid() {
    return this.getStep0MissingFields().length > 0
  }

  getStep1MissingFields() {
    const {
      isUploading,
      isSerialNumberValid,
      isPhoneNoValid,
      isSpeedLimitValid,
      isSpeedSensorValid,
      speedLimit,
      speedSensor,
      portedVehicle,
      isTestingVehicle,
      vehicleSegment,
      selectedVTM,
      videoTelematicsId,
      serialNumber,
      phoneNumber,
      deviceType,
      vehicleMakeId,
      vehicleModelId,
      vehicleMake,
      vehicleModel,
      isDualEngine,
      adblueCapacity,
      eon_voltage,
      eoff_voltage,
      fileNames // Document Upload
    } = this.state

    const missing = []
    if (isUploading) missing.push('File uploading in progress')
    if (!isSerialNumberValid || !serialNumber)
      missing.push('Device Serial Number')
    if (!isPhoneNoValid || !phoneNumber) missing.push('Phone Number')
    if (selectedVTM && !videoTelematicsId) missing.push('Video Telematics ID')

    if (vehicleSegment !== 'DG Set') {
      if (!isSpeedLimitValid || !speedLimit) missing.push('Speed Limit')
      if (!isSpeedSensorValid || !speedSensor) missing.push('Speed Sensor')
      if (portedVehicle === '') missing.push('Ported Vehicle status')
      if (isTestingVehicle === '') missing.push('Testing/Active status')
    }

    if (
      (deviceType === 'obd' || deviceType === 'OBD') &&
      vehicleSegment !== 'DG Set'
    ) {
      if (!vehicleMakeId || !vehicleModelId || !vehicleMake || !vehicleModel)
        missing.push('OBD Make/Model details')
    }

    const isAdblueCapacityValid =
      !(deviceType && deviceType.toLowerCase() === 'obd') ||
      (!!adblueCapacity && adblueCapacity.toString().trim() !== '')
    if (!isAdblueCapacityValid) missing.push('Adblue Capacity')

    const isEonVoltageValid =
      !isDualEngine ||
      (eon_voltage !== null && eon_voltage !== '' && !isNaN(eon_voltage))
    if (!isEonVoltageValid) missing.push('Engine On Voltage')

    const isEoffVoltageValid =
      !isDualEngine ||
      (eoff_voltage !== null && eoff_voltage !== '' && !isNaN(eoff_voltage))
    if (!isEoffVoltageValid) missing.push('Engine Off Voltage')

    if (vehicleSegment === 'DG Set' && !this.state.fuelTankCapacity) {
      missing.push('Fuel Tank Capacity')
    }

    if (!fileNames) missing.push('Document Upload')

    return missing
  }

  isStep1Invalid() {
    return this.getStep1MissingFields().length > 0
  }

  getSubmitMissingFields() {
    const {
      errorMessage,
      errorMessageNew,
      errorMessageFuelTank,
      isInvoiceNoValid,
      invoiceNumber,
      invoiceDate,
      customerType,
      vehicleSegment,
      solution_type,
      tachoidlerpm,
      tachoshifthours
    } = this.state

    let missing = []
    missing = missing.concat(this.getStep0MissingFields())
    missing = missing.concat(this.getStep1MissingFields())

    if (!solution_type || solution_type.length === 0)
      missing.push('Solution Type')

    const VT_SOLUTION_TYPES = ['video_telematics', 'fuel+vt', 'obd+vt', 'fuel+obd+vt']
    const vtSolutionSelected = solution_type && solution_type.some(s => VT_SOLUTION_TYPES.includes(s))
    if (vtSolutionSelected && !this.state.videoTelematicsId && !missing.includes('Video Telematics ID')) {
      missing.push('Video Telematics ID')
    }

    if (this.state.istachoenabled) {
      if (!tachoidlerpm) missing.push('Idle RPM')
      if (!tachoshifthours) missing.push('Shift Hours')
    }

    if (errorMessage) missing.push(errorMessage)
    if (errorMessageNew) missing.push(errorMessageNew)
    if (errorMessageFuelTank) missing.push(errorMessageFuelTank)

    if (customerType == 'Paid' || vehicleSegment == 'DG Set') {
      if (
        !isInvoiceNoValid ||
        !invoiceNumber ||
        !(invoiceDate && invoiceDate.date)
      )
        missing.push('Invoice Details')
    }

    return missing
  }

  isSubmitFormInvalid() {
    return this.getSubmitMissingFields().length > 0
  }

  render() {
    const { uploadProgress } = this.state

    const { classes } = this.props
    let allSpeedSensor = []
    allSpeedSensor[0] = {
      value: 'GPS SPEED SENSOR',
      label: 'Gps speed sensor'
    }
    allSpeedSensor[1] = {
      value: 'DELTA_DISTANCE_CALCULATION',
      label: 'Delta Distance'
    }
    allSpeedSensor[2] = {
      value: 'ODOMETRIC',
      label: 'Odometric'
    }
    let allIdlingSpeed = [
      {
        value: 0,
        label: 0
      },
      {
        value: 1,
        label: 1
      },
      {
        value: 2,
        label: 2
      },
      {
        value: 3,
        label: 3
      }
    ]


    let allvehicleTypes = this.state.vehicleTypes.map(vehicle => ({
      value: vehicle,
      label: vehicle
    }))

    if (this.state.vehicleSegment == 'DG Set') {
      allvehicleTypes = [
        ...this.state.vehicleTypes.map(vehicle => ({
          value: vehicle,
          label: vehicle
        })),
        {
          value: 'DG Set',
          label: 'DG Set'
        }
      ]
    }

    return (
      <div className="Landing">
        <Grid item>
          <Button
            variant="outlined"
            color="primary"
            className="btn"
            onClick={() => this.props.history.goBack()}
          >
            Back
          </Button>
          <Grid
            container
            justify="center"
            className="full-screen"
            alignItems="flex-end"
          />
          <Grid item xs={12}>
            {/* <ItemCard className="form_layout"> */}

            <form>
              <div className="formouter">
                <Grid container>
                  {/* end of customer detaisl */}
                  <Grid item xs={12} sm={12}>
                    <Stepper
                      activeStep={this.state.activeStep}
                      alternativeLabel
                      style={{ background: 'transparent' }}
                    >
                      <Step>
                        <StepButton
                          onClick={() => this.setState({ activeStep: 0 })}
                        >
                          Customer Details
                        </StepButton>
                      </Step>
                      <Step>
                        <StepButton
                          onClick={() => this.setState({ activeStep: 1 })}
                        >
                          Vehicle & Device Info
                        </StepButton>
                      </Step>
                      <Step>
                        <StepButton
                          onClick={() => this.setState({ activeStep: 2 })}
                        >
                          Payment Details & Submission
                        </StepButton>
                      </Step>
                    </Stepper>
                  </Grid>
                  {this.state.activeStep === 0 && (
                    <React.Fragment>
                      <Grid item xs={12} sm={12}>
                        <Grid xs={12} sm={12}>
                          <h3>Customer Details</h3>
                        </Grid>

                        <Grid container className="searchdiv" spacing="8">
                          <Grid item xs={12} sm={12} justify="center">
                            <label
                              style={{
                                marginRight: '20px'
                              }}
                            >
                              Customer Name :{' '}
                            </label>

                            <FormControl
                              style={{
                                minWidth: '50%'
                              }}
                            >
                              <FormGroup className="form-input">
                                {/* <InputLabel htmlFor="selectLabel">
                            Select Client
                          </InputLabel> */}

                                <Select
                                  classes={classes}
                                  options={this.state.clientsDetails}
                                  // components={components}
                                  value={this.state.clientName}
                                  onChange={this.handleChangeClient}
                                  placeholder="Select Customer *"
                                />
                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {!this.state.isClientNameValid
                                    ? 'Invalid Selection'
                                    : ''}
                                </FormHelperText>
                              </FormGroup>
                            </FormControl>
                          </Grid>

                          {this.state.showClientDetails && (
                            <React.Fragment>
                              <ClientDetails
                                clientName={this.state.client}
                                address={this.state.address}
                                city={this.state.city}
                                loginId={this.state.id}
                              />
                              <FormControl
                                className="selectbox"
                                style={{ marginTop: '20px' }}
                              >
                                <FormGroup className="form-input">
                                  <InputLabel
                                    htmlFor="custCode"
                                    style={{ marginTop: '-10px' }}
                                    shrink={!!this.state.customerCode}
                                  >
                                    Customer Code
                                  </InputLabel>
                                  <TextField
                                    style={{ maxWidth: '50%' }}
                                    id="custCode"
                                    name="custCode"
                                    className="textfield"
                                    margin="dense"
                                    type="text"
                                    disabled
                                    value={this.state.customerCode}
                                    onChange={this.handleInputChange(
                                      'customerCode'
                                    )}
                                    InputProps={{ readOnly: true }}
                                  //error={!this.state.isrcRegnDtValid}
                                  />

                                </FormGroup>
                              </FormControl>

                              <FormControl
                                className="selectbox"
                                style={{ marginTop: '20px' }}
                              >
                                <FormGroup className="form-input">
                                  <InputLabel
                                    htmlFor="custType"
                                    style={{ marginTop: '-10px' }}
                                    shrink={!!this.state.customerType}
                                  >
                                    Customer Type
                                  </InputLabel>
                                  <TextField
                                    style={{ maxWidth: '50%' }}
                                    id="custType"
                                    name="custType"
                                    className="textfield"
                                    margin="dense"
                                    type="text"
                                    disabled
                                    value={this.state.customerType}
                                    onChange={this.handleInputChange(
                                      'customerType'
                                    )}
                                    InputProps={{ readOnly: true }}
                                  //error={!this.state.isrcRegnDtValid}
                                  />

                                </FormGroup>
                              </FormControl>

                            </React.Fragment>
                          )}
                        </Grid>
                        {/* customer deatisl end  */}

                        {/* end of auto fill section  */}
                        {this.state.vehicleSegment !== 'DG Set' && (
                          <FormControlLabel
                            style={{ marginTop: '20px' }}
                            label="Vehicle Registration Number Available"
                            control={
                              <Checkbox
                                checked={
                                  this.state
                                    .vehicleRegistrationNumberAvailableStatus
                                }
                                onChange={this.handleVehicleRegistrationNumberAvailableChange(
                                  'vehicleRegistrationNumberAvailableStatus'
                                )}
                                value="vehicleRegistrationNumberAvailableStatus"
                                color="primary"
                              />
                            }
                          />
                        )}

                        {this.state.vehicleSegment !== 'DG Set' &&
                          this.state.vehicleRegistrationNumberAvailableStatus &&
                          (this.state.loading ? (
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100px'
                              }}
                            >
                              <CircularProgress />
                            </div>
                          ) : (
                            <Grid item xs={12} sm={12} justify="center">
                              <label style={{ marginRight: '20px' }}>
                                Vehicle Registration Number *{' '}
                              </label>
                              <FormControl style={{ minWidth: '50%' }}>
                                {/* <FormGroup className="form-input"> */}
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  margin="normal"
                                  value={
                                    this.state.enteredVehicleRegistrationNumber
                                  }
                                  // onChange={
                                  //   this.checkVlpnValidity
                                  // }
                                  placeholder="Enter Vehicle Registration Number *"
                                  name="enteredVehicleRegistrationNumber"
                                  onChange={event =>
                                    this.setState({
                                      enteredVehicleRegistrationNumber:
                                        event.target.value
                                    })
                                  }
                                />

                              </FormControl>
                              <Button
                                color="default"
                                variant="outlined"
                                size="medium"
                                margin="normal"
                                className="btn"
                                onClick={this.getDataByVehicleNumber}
                              >
                                Get Data
                              </Button>
                              {this.state.vlpnres && (
                                <FormHelperText className="Error_msg">
                                  {this.state.vlpnres}
                                </FormHelperText>
                              )}
                            </Grid>
                          ))}

                        {this.state.vehicleSegment !== 'DG Set' && (
                          <Grid item xs={12} sm={12}>
                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '10px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcRegnNo"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    !!(
                                      this.state.rcRegnNo ||
                                      (this.state.vehicleData &&
                                        this.state.vehicleData.rcRegnNo)
                                    )
                                  }
                                >
                                  Vehicle Registration Number *
                                </InputLabel>
                                <TextField
                                  id="rcRegnNo"
                                  name="rcRegnNo"
                                  className="textfield"
                                  margin="dense"
                                  type="text"
                                  value={
                                    this.state.vehicleData
                                      ? this.state.vehicleData.rcRegnNo
                                      : this.state.rcRegnNo
                                  }
                                  required
                                  onChange={this.handleInputChange('rcRegnNo')}
                                />
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcMakerDesc"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    !!(
                                      this.state.rcMakerDesc ||
                                      (this.state.vehicleData &&
                                        this.state.vehicleData.rcMakerDesc)
                                    )
                                  }
                                >
                                  Maker Description *
                                </InputLabel>
                                <TextField
                                  id="rcMakerDesc"
                                  name="rcMakerDesc"
                                  className="textfield"
                                  margin="dense"
                                  type="text"
                                  value={
                                    this.state.vehicleData
                                      ? this.state.vehicleData.rcMakerDesc
                                      : this.state.rcMakerDesc
                                  }
                                  onChange={this.handleInputChange(
                                    'rcMakerDesc'
                                  )}
                                />
                              </FormGroup>
                            </FormControl>

                            <FormControl
                              className="selectbox"
                              style={{ marginTop: '20px' }}
                            >
                              <FormGroup className="form-input">
                                <InputLabel
                                  htmlFor="rcMakerModel"
                                  style={{ marginTop: '-10px' }}
                                  shrink={
                                    !!(
                                      this.state.rcMakerModel ||
                                      (this.state.vehicleData &&
                                        this.state.vehicleData.rcMakerModel)
                                    )
                                  }
                                >
                                  Maker Model *
                                </InputLabel>
                                <TextField
                                  id="rcMakerModel"
                                  name="rcMakerModel"
                                  className="textfield"
                                  margin="dense"
                                  type="text"
                                  value={
                                    this.state.vehicleData
                                      ? this.state.vehicleData.rcMakerModel
                                      : this.state.rcMakerModel
                                  }
                                  onChange={this.handleInputChange(
                                    'rcMakerModel'
                                  )}
                                />
                              </FormGroup>
                            </FormControl>
                          </Grid>
                        )}

                        <Grid
                          container
                          fullwidth
                          style={{
                            marginTop: '20px'
                          }}
                        >
                          {/* Segment Dropdown */}
                          <Grid item xs={6} sm={6}>
                            <FormControl className="selectbox">
                              <FormGroup className="form-input">
                                <label>Vehicle Segment *</label>
                                <Select
                                  // options={this.state.segmentOptions}
                                  options={
                                    Array.isArray(this.state.vehiclesegment) &&
                                    this.state.vehiclesegment.map(option => ({
                                      label: option,
                                      value: option
                                    }))
                                  }
                                  value={this.state.vehicleSegment}
                                  onChange={this.handleSegmentChange}
                                  placeholder="Vehicle Segment *"
                                />
                              </FormGroup>
                            </FormControl>





                            {/* Application Dropdown */}
                            {this.state.vehicleSegment === 'Transportation' && (
                              <FormControl
                                className="selectbox"
                                style={{ marginTop: '16px' }}
                              >
                                <FormGroup className="form-input">
                                  <label>Transportation Vehicle Type *</label>

                                  <Select
                                    // options={this.state.constructionVehicleTypeOptions}
                                    options={
                                      Array.isArray(
                                        this.state.transportationvehicletype
                                      ) &&
                                      this.state.transportationvehicletype.map(
                                        option => ({
                                          label: option,
                                          value: option
                                        })
                                      )
                                    }
                                    value={this.state.transportationVehicleType}
                                    onChange={selectedOption =>
                                      this.setState({
                                        transportationVehicleType: selectedOption
                                          ? selectedOption.value
                                          : ''
                                      })
                                    }
                                    placeholder="Select Transportation Vehicle Type *"
                                  />
                                </FormGroup>
                              </FormControl>
                            )}

                            {this.state.vehicleSegment === 'Transportation' && (
                              <FormControl
                                className="selectbox"
                                style={{ marginTop: '16px' }}
                              >
                                <FormGroup className="form-input">
                                  <label>Application *</label>

                                  <Select
                                    // options={this.state.applicationOptions}
                                    options={
                                      Array.isArray(this.state.application) &&
                                      this.state.application.map(option => ({
                                        label: option,
                                        value: option
                                      }))
                                    }
                                    value={this.state.selectedApplication}
                                    onChange={selectedOption =>
                                      this.setState({
                                        selectedApplication: selectedOption
                                          ? selectedOption.value
                                          : ''
                                      })
                                    }
                                    placeholder="Select Application *"
                                  />
                                </FormGroup>
                              </FormControl>
                            )}

                            {/* Haulage Type Dropdown */}

                            {this.state.vehicleSegment === 'Transportation' && (
                              <FormControl
                                className="selectbox"
                                style={{ marginTop: '16px' }}
                              >
                                <FormGroup className="form-input">
                                  <label>Haulage Type *</label>

                                  <Select
                                    // options={this.state.haulageTypeOptions}
                                    options={
                                      Array.isArray(this.state.haulagetype) &&
                                      this.state.haulagetype.map(option => ({
                                        label: option,
                                        value: option
                                      }))
                                    }
                                    value={this.state.haulageType}
                                    onChange={selectedOption =>
                                      this.setState({
                                        haulageType: selectedOption
                                          ? selectedOption.value
                                          : ''
                                      })
                                    }
                                    placeholder="Select Haulage Type *"
                                  />
                                </FormGroup>
                              </FormControl>
                            )}



                            {/* Construction Vehicle Type Dropdown */}
                            {this.state.vehicleSegment === 'Construction' && (
                              <FormControl
                                className="selectbox"
                                style={{ marginTop: '16px' }}
                              >
                                <FormGroup className="form-input">
                                  <label>Construction Vehicle Type *</label>

                                  <Select
                                    // options={this.state.constructionVehicleTypeOptions}
                                    options={
                                      Array.isArray(
                                        this.state.constructionvehicletype
                                      ) &&
                                      this.state.constructionvehicletype.map(
                                        option => ({
                                          label: option,
                                          value: option
                                        })
                                      )
                                    }
                                    value={this.state.constructionVehicleType}
                                    onChange={selectedOption =>
                                      this.setState({
                                        constructionVehicleType: selectedOption
                                          ? selectedOption.value
                                          : ''
                                      })
                                    }
                                    placeholder="Select Construction Vehicle Type *"
                                  />
                                </FormGroup>
                              </FormControl>
                            )}

                            {this.state.vehicleSegment === 'Construction' &&
                              this.state.constructionVehicleType ===
                              'Tensioner' && (
                                <FormControl
                                  className="selectbox"
                                  style={{ marginTop: '16px' }}
                                >
                                  <FormGroup className="form-input">
                                    <label>Conductor Length (in km) *</label>
                                    <Input
                                      type="number"
                                      placeholder="Conductor Length (in m)"
                                      value={
                                        this.state.tensionerConductorLength
                                      }
                                      onChange={e => {
                                        this.setState({
                                          tensionerConductorLength:
                                            Number(e.target.value) < 0
                                              ? 0
                                              : Number(e.target.value)
                                        })
                                      }}
                                    />
                                  </FormGroup>
                                </FormControl>
                              )}

                            {this.state.vehicleSegment === 'Construction' &&
                              this.state.constructionVehicleType ===
                              'Tensioner' && (
                                <FormControl
                                  className="selectbox"
                                  style={{ marginTop: '16px' }}
                                >
                                  <FormGroup className="form-input">
                                    <label>Rotation Sensor Direction *</label>
                                    <Select
                                      options={[
                                        {
                                          value: 'clockwise',
                                          label: 'Clockwise'
                                        },
                                        {
                                          value: 'anticlockwise',
                                          label: 'Anticlockwise'
                                        }
                                      ]}
                                      value={
                                        this.state
                                          .tensionerRotationSensorDirection
                                          ? {
                                            value:
                                              this.state
                                                .tensionerRotationSensorDirection,
                                            label:
                                              this.state
                                                .tensionerRotationSensorDirection ===
                                                'clockwise'
                                                ? 'Clockwise'
                                                : 'Anticlockwise'
                                          }
                                          : null
                                      }
                                      onChange={selectedOption =>
                                        this.setState({
                                          tensionerRotationSensorDirection:
                                            selectedOption
                                              ? selectedOption.value
                                              : ''
                                        })
                                      }
                                      placeholder="Select Rotation Sensor Direction *"
                                    />
                                  </FormGroup>
                                </FormControl>
                              )}

                            {this.state.vehicleSegment === 'Construction' &&
                              this.state.constructionVehicleType === 'Tensioner' && (
                                <TensionerRotationSensorReminder />
                              )}

                            {this.state.vehicleSegment === 'Passenger' && (
                              <FormControl
                                className="selectbox"
                                style={{ marginTop: '16px' }}
                              >
                                <FormGroup className="form-input">
                                  <label>Passenger Vehicle Type *</label>

                                  <Select
                                    // options={this.state.constructionVehicleTypeOptions}
                                    options={
                                      Array.isArray(
                                        this.state.passengervehicletype
                                      ) &&
                                      this.state.passengervehicletype.map(
                                        option => ({
                                          label: option,
                                          value: option
                                        })
                                      )
                                    }
                                    value={this.state.passengerVehicleType}
                                    onChange={selectedOption =>
                                      this.setState({
                                        passengerVehicleType: selectedOption
                                          ? selectedOption.value
                                          : ''
                                      })
                                    }
                                    placeholder="Select Passenger Vehicle Type *"
                                  />
                                </FormGroup>
                              </FormControl>
                            )}


                          </Grid>
                        </Grid>

                        <div
                          style={{
                            flex: 1,
                            backgroundColor: '#f2f2f2',
                            padding: '10px',
                            borderRadius: '5px'
                          }}
                        >
                          <h4
                            className="autoFillHeader"
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              this.setState(prevState => ({
                                isAutoFillEntrySectionOpen: !prevState.isAutoFillEntrySectionOpen
                              }))
                            }
                          >
                            <span
                              className={
                                this.state.isAutoFillEntrySectionOpen
                                  ? 'autoFillChevron open'
                                  : 'autoFillChevron'
                              }
                            />
                            Auto Fill Entry Section
                          </h4>

                          {this.state.isAutoFillEntrySectionOpen && (
                            <div>
                              {this.state.vehicleSegment != 'DG Set' && (
                                <Grid xs={12} sm={12} mt={4}>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcRegnDt"
                                        style={{ marginTop: '-10px' }}
                                        // shrink={((this.state.vehicleData && this.state.vehicleData.rcRegnDt)|| this.state.rcRegnDt)}
                                        shrink={
                                          !!(
                                            this.state.rcRegnDt ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.rcRegnDt)
                                          )
                                        }
                                      >
                                        Registration Date
                                      </InputLabel>
                                      <TextField
                                        id="rcRegnDt"
                                        name="rcRegnDt"
                                        className="textfield"
                                        margin="dense"
                                        //label="Registration Date"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcRegnDt
                                            : this.state.rcRegnDt
                                        }
                                        // value={(this.state.vehicleData && this.state.vehicleData.rcRegnDt) || ''}
                                        onChange={this.handleInputChange(
                                          'rcRegnDt'
                                        )}
                                      //error={!this.state.isrcRegnDtValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcRegnUpto"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcRegnUpto ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.rcRegnUpto)
                                          )
                                        }
                                      >
                                        Registration Valid Upto
                                      </InputLabel>
                                      <TextField
                                        id="rcRegnUpto"
                                        name="rcRegnUpto"
                                        className="textfield"
                                        margin="dense"
                                        //label="Registration Valid Upto"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcRegnUpto
                                            : this.state.rcRegnUpto
                                        }
                                        onChange={this.handleInputChange(
                                          'rcRegnUpto'
                                        )}
                                      //error={!this.state.isrcRegnUptoValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="stateCd"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.stateCd ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.stateCd)
                                          )
                                        }
                                      >
                                        State Code
                                      </InputLabel>
                                      <TextField
                                        id="stateCd"
                                        name="stateCd"
                                        className="textfield"
                                        margin="dense"
                                        //label="State Code"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.stateCd
                                            : this.state.stateCd
                                        }
                                        onChange={this.handleInputChange(
                                          'stateCd'
                                        )}
                                      //error={!this.state.isstateCdValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rtoCd"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rtoCd ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.rtoCd)
                                          )
                                        }
                                      >
                                        RTO Code
                                      </InputLabel>
                                      <TextField
                                        id="rtoCd"
                                        name="rtoCd"
                                        className="textfield"
                                        margin="dense"
                                        //label="RTO Code"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rtoCd
                                            : this.state.rtoCd
                                        }
                                        onChange={this.handleInputChange(
                                          'rtoCd'
                                        )}
                                      //error={!this.state.isrtoCdValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcVchCatg"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcVchCatg ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.rcVchCatg)
                                          )
                                        }
                                      >
                                        Vehicle Category Code
                                      </InputLabel>
                                      <TextField
                                        id="rcVchCatg"
                                        name="rcVchCatg"
                                        className="textfield"
                                        margin="dense"
                                        //label="Vehicle Category Code"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcVchCatg
                                            : this.state.rcVchCatg
                                        }
                                        onChange={this.handleInputChange(
                                          'rcVchCatg'
                                        )}
                                      //error={!this.state.isrcVchCatgValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcVhClassDesc"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcVhClassDesc ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcVhClassDesc)
                                          )
                                        }
                                      >
                                        Vehicle Class Description
                                      </InputLabel>
                                      <TextField
                                        id="rcVhClassDesc"
                                        name="rcVhClassDesc"
                                        className="textfield"
                                        margin="dense"
                                        //label="Vehicle Class Description"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData
                                              .rcVhClassDesc
                                            : this.state.rcVhClassDesc
                                        }
                                        onChange={this.handleInputChange(
                                          'rcVhClassDesc'
                                        )}
                                      //error={!this.state.isrcVhClassDescValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcChasiNo"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcChasiNo ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.rcChasiNo)
                                          )
                                        }
                                      >
                                        Chassis Number
                                      </InputLabel>
                                      <TextField
                                        id="rcChasiNo"
                                        name="rcChasiNo"
                                        className="textfield"
                                        margin="dense"
                                        //label="Chassis Number"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcChasiNo
                                            : this.state.rcChasiNo
                                        }
                                        onChange={this.handleInputChange(
                                          'rcChasiNo'
                                        )}
                                      //error={!this.state.isrcChasiNoValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcEngNo"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcEngNo ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.rcEngNo)
                                          )
                                        }
                                      >
                                        Engine Number
                                      </InputLabel>
                                      <TextField
                                        id="rcEngNo"
                                        name="rcEngNo"
                                        className="textfield"
                                        margin="dense"
                                        //label="Engine Number"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcEngNo
                                            : this.state.rcEngNo
                                        }
                                        onChange={this.handleInputChange(
                                          'rcEngNo'
                                        )}
                                      //error={!this.state.isrcEngNoValid}
                                      />

                                    </FormGroup>
                                  </FormControl>



                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcBodyTypeDesc"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcBodyTypeDesc ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcBodyTypeDesc)
                                          )
                                        }
                                      >
                                        Body Type Description
                                      </InputLabel>
                                      <TextField
                                        id="rcBodyTypeDesc"
                                        name="rcBodyTypeDesc"
                                        className="textfield"
                                        margin="dense"
                                        //label="Body Type Description"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData
                                              .rcBodyTypeDesc
                                            : this.state.rcBodyTypeDesc
                                        }
                                        onChange={this.handleInputChange(
                                          'rcBodyTypeDesc'
                                        )}
                                      //error={!this.state.isrcBodyTypeDescValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <Grid
                                    xs={12}
                                    sm={12}
                                    mt={4}
                                    style={{ marginTop: '20px' }}
                                  >
                                    Fuel Type
                                  </Grid>
                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '5px' }}
                                  >
                                    <FormGroup className="form-input">

                                      {this.state.vehicleSegment !==
                                        'DG Set' && (
                                          <Select
                                            id="rcFuelDesc"
                                            name="rcFuelDesc"
                                            classes={classes}
                                            options={[
                                              {
                                                value: 'petrol',
                                                label: 'PETROL'
                                              },
                                              {
                                                value: 'diesel',
                                                label: 'DIESEL'
                                              },
                                              { value: 'ev', label: 'EV' },
                                              { value: 'cng', label: 'CNG' },
                                              { value: 'lng', label: 'LNG' }
                                            ]}
                                            // components={components}
                                            // value={this.state.rcFuelDesc}
                                            value={
                                              this.state.vehicleData &&
                                                this.state.vehicleData.rcFuelDesc
                                                ? this.state.vehicleData.rcFuelDesc.toLowerCase()
                                                : this.state.rcFuelDesc
                                            }
                                            onChange={selectedOption => {
                                              this.setState({
                                                rcFuelDesc: selectedOption
                                                  ? selectedOption.value
                                                  : ''
                                              })
                                            }}
                                            placeholder="Fuel Type"
                                          //disabled={this.state.fuelTypeFromApi}
                                          />
                                        )}
                                      {this.state.vehicleSegment ===
                                        'DG Set' && (
                                          <Select
                                            id="rcFuelDesc"
                                            name="rcFuelDesc"
                                            classes={classes}
                                            options={[
                                              {
                                                value: 'petrol',
                                                label: 'PETROL'
                                              },
                                              { value: 'diesel', label: 'DIESEL' }
                                            ]}
                                            // components={components}
                                            //value={this.state.fuelType}
                                            value={
                                              this.state.vehicleData
                                                ? this.state.vehicleData
                                                  .rcFuelDesc
                                                : this.state.rcFuelDesc
                                            }
                                            onChange={selectedOption => {
                                              this.setState({
                                                rcFuelDesc: selectedOption
                                                  ? selectedOption.value
                                                  : ''
                                              })
                                            }}
                                            placeholder="Fuel Type"
                                          //disabled={this.state.fuelTypeFromApi}
                                          />
                                        )}
                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcNormsDesc"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcNormsDesc ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcNormsDesc)
                                          )
                                        }
                                      >
                                        Emission Norms Description
                                      </InputLabel>
                                      <TextField
                                        id="rcNormsDesc"
                                        name="rcNormsDesc"
                                        className="textfield"
                                        margin="dense"
                                        //label="Emission Norms Description"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcNormsDesc
                                            : this.state.rcNormsDesc
                                        }
                                        onChange={this.handleInputChange(
                                          'rcNormsDesc'
                                        )}
                                      //error={!this.state.isrcNormsDescValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcFitUpto"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcFitUpto ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.rcFitUpto)
                                          )
                                        }
                                      >
                                        Fitment Upto
                                      </InputLabel>
                                      <TextField
                                        id="rcFitUpto"
                                        name="rcFitUpto"
                                        className="textfield"
                                        margin="dense"
                                        //label="Fitment Upto"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcFitUpto
                                            : this.state.rcFitUpto
                                        }
                                        onChange={this.handleInputChange(
                                          'rcFitUpto'
                                        )}
                                      //error={!this.state.isrcFitUptoValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcNpUpto"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcNpUpto ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.rcNpUpto)
                                          )
                                        }
                                      >
                                        National Permit Upto
                                      </InputLabel>
                                      <TextField
                                        id="rcNpUpto"
                                        name="rcNpUpto"
                                        className="textfield"
                                        margin="dense"
                                        //label="National Permit Upto"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcNpUpto
                                            : this.state.rcNpUpto
                                        }
                                        onChange={this.handleInputChange(
                                          'rcNpUpto'
                                        )}
                                      //error={!this.state.isrcNpUptoValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcTaxUpto"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcTaxUpto ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.rcTaxUpto)
                                          )
                                        }
                                      >
                                        Tax Upto
                                      </InputLabel>
                                      <TextField
                                        id="rcTaxUpto"
                                        name="rcTaxUpto"
                                        className="textfield"
                                        margin="dense"
                                        //label="Tax Upto"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcTaxUpto
                                            : this.state.rcTaxUpto
                                        }
                                        onChange={this.handleInputChange(
                                          'rcTaxUpto'
                                        )}
                                      //error={!this.state.isrcTaxUptoValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcInsuranceComp"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcInsuranceComp ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcInsuranceComp)
                                          )
                                        }
                                      >
                                        Insurer Name
                                      </InputLabel>
                                      <TextField
                                        id="rcInsuranceComp"
                                        name="rcInsuranceComp"
                                        className="textfield"
                                        margin="dense"
                                        //label="Insurer Name"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData
                                              .rcInsuranceComp
                                            : this.state.rcInsuranceComp
                                        }
                                        onChange={this.handleInputChange(
                                          'rcInsuranceComp'
                                        )}
                                      //error={!this.state.isrcInsuranceCompValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcInsuranceUpto"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcInsuranceUpto ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcInsuranceUpto)
                                          )
                                        }
                                      >
                                        Insurer Upto
                                      </InputLabel>
                                      <TextField
                                        id="rcInsuranceUpto"
                                        name="rcInsuranceUpto"
                                        className="textfield"
                                        margin="dense"
                                        //label="Insurance Upto"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData
                                              .rcInsuranceUpto
                                            : this.state.rcInsuranceUpto
                                        }
                                        onChange={this.handleInputChange(
                                          'rcInsuranceUpto'
                                        )}
                                      //error={!this.state.isrcInsuranceUptoValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcManuMonthYr"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcManuMonthYr ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcManuMonthYr)
                                          )
                                        }
                                      >
                                        Manufacturing Month/Year
                                      </InputLabel>
                                      <TextField
                                        id="rcManuMonthYr"
                                        name="rcManuMonthYr"
                                        className="textfield"
                                        margin="dense"
                                        //label="Manufacturing Month/Year"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData
                                              .rcManuMonthYr
                                            : this.state.rcManuMonthYr
                                        }
                                        onChange={this.handleInputChange(
                                          'rcManuMonthYr'
                                        )}
                                      //error={!this.state.isrcManuMonthYrValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcUnldWt"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcUnldWt ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.rcUnldWt)
                                          )
                                        }
                                      >
                                        Unladen Weight
                                      </InputLabel>
                                      <TextField
                                        id="rcUnldWt"
                                        name="rcUnldWt"
                                        className="textfield"
                                        margin="dense"
                                        //label="Unladen Weight"
                                        type="number"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcUnldWt
                                            : this.state.rcUnldWt
                                        }
                                        onChange={this.handleInputChange(
                                          'rcUnldWt'
                                        )}
                                      //error={!this.state.isrcUnldWtValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcGvw"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcGvw ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.rcGvw)
                                          )
                                        }
                                      >
                                        Gross Vehicle Weight (GVW)
                                      </InputLabel>
                                      <TextField
                                        id="rcGvw"
                                        name="rcGvw"
                                        className="textfield"
                                        margin="dense"

                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcGvw
                                            : this.state.rcGvw
                                        }
                                        onChange={this.handleInputChange(
                                          'rcGvw'
                                        )}
                                        type="number"
                                        inputProps={{ step: '0.01' }}
                                      //error={!this.state.isrcGvwValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcRegisteredAt"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcRegisteredAt ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcRegisteredAt)
                                          )
                                        }
                                      >
                                        Registered At
                                      </InputLabel>
                                      <TextField
                                        id="rcRegisteredAt"
                                        name="rcRegisteredAt"
                                        className="textfield"
                                        margin="dense"
                                        //label="Registered At"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData
                                              .rcRegisteredAt
                                            : this.state.rcRegisteredAt
                                        }
                                        onChange={this.handleInputChange(
                                          'rcRegisteredAt'
                                        )}
                                      //error={!this.state.isrcRegisteredAtValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcPuccUpto"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcPuccUpto ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.rcPuccUpto)
                                          )
                                        }
                                      >
                                        Pollution Under Control Certificate
                                        (PUCC) Upto
                                      </InputLabel>
                                      <TextField
                                        id="rcPuccUpto"
                                        name="rcPuccUpto"
                                        className="textfield"
                                        margin="dense"
                                        //label="Pollution Under Control Certificate (PUCC) Upto"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcPuccUpto
                                            : this.state.rcPuccUpto
                                        }
                                        onChange={this.handleInputChange(
                                          'rcPuccUpto'
                                        )}
                                      //error={!this.state.isrcPuccUptoValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcPermitNo"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcPermitNo ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData.rcPermitNo)
                                          )
                                        }
                                      >
                                        Permit Number
                                      </InputLabel>
                                      <TextField
                                        id="rcPermitNo"
                                        name="rcPermitNo"
                                        className="textfield"
                                        margin="dense"
                                        //label="Permit Number"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcPermitNo
                                            : this.state.rcPermitNo
                                        }
                                        onChange={this.handleInputChange(
                                          'rcPermitNo'
                                        )}
                                      //error={!this.state.isrcPermitNoValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcPermitIssueDt"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcPermitIssueDt ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcPermitIssueDt)
                                          )
                                        }
                                      >
                                        Permit Issue Date
                                      </InputLabel>
                                      <TextField
                                        id="rcPermitIssueDt"
                                        name="rcPermitIssueDt"
                                        className="textfield"
                                        margin="dense"
                                        //label="Permit Issue Date"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData
                                              .rcPermitIssueDt
                                            : this.state.rcPermitIssueDt
                                        }
                                        onChange={this.handleInputChange(
                                          'rcPermitIssueDt'
                                        )}
                                      //error={!this.state.isrcPermitIssueDtValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcPermitValidFrom"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcPermitValidFrom ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcPermitValidFrom)
                                          )
                                        }
                                      >
                                        Permit Valid From
                                      </InputLabel>
                                      <TextField
                                        id="rcPermitValidFrom"
                                        name="rcPermitValidFrom"
                                        className="textfield"
                                        margin="dense"
                                        //label="Permit Valid From"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData
                                              .rcPermitValidFrom
                                            : this.state.rcPermitValidFrom
                                        }
                                        onChange={this.handleInputChange(
                                          'rcPermitValidFrom'
                                        )}
                                      //error={!this.state.isrcPermitValidFromValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcPermitValidUpto"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            this.state.rcPermitValidUpto ||
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcPermitValidUpto)
                                          )
                                        }
                                      >
                                        Permit Valid Upto
                                      </InputLabel>
                                      <TextField
                                        id="rcPermitValidUpto"
                                        name="rcPermitValidUpto"
                                        className="textfield"
                                        margin="dense"
                                        //label="Permit Valid Upto"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData
                                              .rcPermitValidUpto
                                            : this.state.rcPermitValidUpto
                                        }
                                        onChange={this.handleInputChange(
                                          'rcPermitValidUpto'
                                        )}
                                      //error={!this.state.isrcPermitValidUptoValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcPermitType"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcPermitType) ||
                                            this.state.rcPermitType
                                          )
                                        }
                                      >
                                        Permit Type
                                      </InputLabel>
                                      <TextField
                                        id="rcPermitType"
                                        name="rcPermitType"
                                        className="textfield"
                                        margin="dense"
                                        //label="Permit Type"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData
                                              .rcPermitType
                                            : this.state.rcPermitType
                                        }
                                        onChange={this.handleInputChange(
                                          'rcPermitType'
                                        )}
                                      //error={!this.state.isrcPermitTypeValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcPermitCode"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcPermitCode) ||
                                            this.state.rcPermitCode
                                          )
                                        }
                                      >
                                        Permit Code
                                      </InputLabel>
                                      <TextField
                                        id="rcPermitCode"
                                        name="rcPermitCode"
                                        className="textfield"
                                        margin="dense"
                                        //label="Permit Code"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData
                                              .rcPermitCode
                                            : this.state.rcPermitCode
                                        }
                                        onChange={this.handleInputChange(
                                          'rcPermitCode'
                                        )}
                                      //error={!this.state.isrcPermitCodeValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcNoOfAxle"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcNoOfAxle) ||
                                            this.state.rcNoOfAxle
                                          )
                                        }
                                      >
                                        Number of Axles
                                      </InputLabel>
                                      <TextField
                                        id="rcNoOfAxle"
                                        name="rcNoOfAxle"
                                        className="textfield"
                                        margin="dense"
                                        //label="Number of Axles"
                                        type="number"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcNoOfAxle
                                            : this.state.rcNoOfAxle
                                        }
                                        onChange={this.handleInputChange(
                                          'rcNoOfAxle'
                                        )}
                                      //error={!this.state.isrcNoOfAxleValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcFuelCd"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcFuelCd) ||
                                            this.state.rcFuelCd
                                          )
                                        }
                                      >
                                        Fuel Code
                                      </InputLabel>
                                      <TextField
                                        id="rcFuelCd"
                                        name="rcFuelCd"
                                        className="textfield"
                                        margin="dense"
                                        //label="Fuel Code"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcFuelCd
                                            : this.state.rcFuelCd
                                        }
                                        onChange={this.handleInputChange(
                                          'rcFuelCd'
                                        )}
                                      //error={!this.state.isrcFuelCdValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcVhType"
                                        style={{ marginTop: '-10px' }}
                                        shrink={(() => {
                                          const {
                                            vehicleSegment,
                                            transportationVehicleType,
                                            constructionVehicleType,
                                            passengerVehicleType,
                                            vehicleData,
                                            rcVhType
                                          } = this.state

                                          if (
                                            vehicleSegment === 'Transportation'
                                          )
                                            return !!transportationVehicleType
                                          if (vehicleSegment === 'Construction')
                                            return !!constructionVehicleType
                                          if (vehicleSegment === 'Passenger')
                                            return !!passengerVehicleType

                                          return !!(
                                            vehicleSegment ||
                                            rcVhType ||
                                            (vehicleData &&
                                              vehicleData.rcVhType)
                                          )
                                        })()}
                                      >
                                        Vehicle Type
                                      </InputLabel>
                                      <TextField
                                        id="rcVhType"
                                        name="rcVhType"
                                        className="textfield"
                                        margin="dense"
                                        //label="Vehicle Type"
                                        type="text"
                                        // type="Multi-line"
                                        value={(() => {
                                          const {
                                            vehicleSegment,
                                            transportationVehicleType,
                                            constructionVehicleType,
                                            passengerVehicleType,
                                            vehicleData,
                                            rcVhType
                                          } = this.state

                                          if (
                                            vehicleSegment === 'Transportation'
                                          )
                                            return (
                                              transportationVehicleType || ''
                                            )
                                          if (vehicleSegment === 'Construction')
                                            return constructionVehicleType || ''
                                          if (vehicleSegment === 'Passenger')
                                            return passengerVehicleType || ''

                                          return (
                                            vehicleSegment ||
                                            rcVhType ||
                                            (vehicleData &&
                                              vehicleData.rcVhType)
                                          )
                                        })()}
                                        onChange={this.handleInputChange(
                                          'rcVhType'
                                        )}
                                      //error={!this.state.isrcVhTypeValid}
                                      />

                                    </FormGroup>
                                  </FormControl>

                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '20px' }}
                                  >
                                    <FormGroup className="form-input">
                                      <InputLabel
                                        htmlFor="rcVhClass"
                                        style={{ marginTop: '-10px' }}
                                        shrink={
                                          !!(
                                            (this.state.vehicleData &&
                                              this.state.vehicleData
                                                .rcVhClass) ||
                                            this.state.rcVhClass
                                          )
                                        }
                                      >
                                        Vehicle Class
                                      </InputLabel>
                                      <TextField
                                        id="rcVhClass"
                                        name="rcVhClass"
                                        className="textfield"
                                        margin="dense"
                                        //label="Vehicle Class"
                                        type="text"
                                        // type="Multi-line"
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcVhClass
                                            : this.state.rcVhClass
                                        }
                                        onChange={this.handleInputChange(
                                          'rcVhClass'
                                        )}
                                      //error={!this.state.isrcVhClassValid}
                                      />

                                    </FormGroup>
                                  </FormControl>
                                </Grid>
                              )}


                              {this.state.vehicleSegment == 'DG Set' && (
                                <Grid
                                  xs={12}
                                  sm={12}
                                  mt={4}
                                  style={{ marginTop: '15px' }}
                                >
                                  Vehicle/Asset Type *
                                  {/* {this.state.vehicleSegment == 'DG Set' ? 'Vehicle/Asset Type' : 'Vehicle Type'} *                         */}
                                  <FormControl className="selectbox">
                                    <FormGroup className="form-input">
                                      <Select
                                        classes={classes}
                                        options={allvehicleTypes}
                                        value={this.state.vehicleType}
                                        onChange={this.handleChangeType}
                                        placeholder="Select vehicle Type"
                                        disabled={
                                          this.state.vehicleSegment == 'DG Set'
                                            ? true
                                            : false
                                        }
                                      />
                                      <FormHelperText
                                        id="name-error-text"
                                        className="Error_msg"
                                      >
                                        {!this.state.isClientNameValid
                                          ? 'Invalid Selection'
                                          : ''}
                                      </FormHelperText>
                                    </FormGroup>
                                  </FormControl>
                                </Grid>
                              )}



                              {this.state.vehicleSegment == 'DG Set' && (
                                <div>
                                  <Grid xs={12} sm={12} mt={4}>
                                    Select Make *
                                  </Grid>
                                  <FormControl className="selectbox">
                                    <FormGroup className="form-input">
                                      <Select
                                        id="vehicleMake"
                                        name="vehicleMake"
                                        classes={classes}
                                        options={this.state.makesList.map(
                                          item => ({
                                            value: item.id,
                                            label: item.make
                                          })
                                        )}
                                        value={this.state.vehicleMakeId}
                                        onChange={this.handleChangeMake}
                                        placeholder="Select"
                                      />
                                      <FormHelperText
                                        id="name-error-text"
                                        className="Error_msg"
                                      >
                                        {!this.state.isVehicleMakeValid
                                          ? 'Invalid Vehicle Make'
                                          : ''}
                                      </FormHelperText>
                                    </FormGroup>
                                  </FormControl>
                                </div>
                              )}

                              {this.state.vehicleSegment == 'DG Set' && (
                                <div>
                                  <Grid xs={12} sm={12} mt={4}>
                                    Select Model *
                                  </Grid>
                                  <FormControl className="selectbox">
                                    <FormGroup className="form-input">
                                      <Select
                                        id="vehicleModel"
                                        name="vehicleModel"
                                        classes={classes}
                                        options={this.state.modelsList.map(
                                          item => ({
                                            value: item.id,
                                            label: item.model
                                          })
                                        )}
                                        value={this.state.vehicleModelId}
                                        onChange={this.handleChangeModel}
                                        placeholder="Select"
                                        error={!this.state.isVehicleModelValid}
                                      />
                                      <FormHelperText
                                        id="name-error-text"
                                        className="Error_msg"
                                      >
                                        {!this.state.isVehicleModelValid
                                          ? 'Invalid Vehicle Model'
                                          : ''}
                                      </FormHelperText>
                                    </FormGroup>
                                  </FormControl>
                                </div>
                              )}

                              {this.state.vehicleSegment == 'DG Set' && (
                                <div>
                                  <Grid xs={12} sm={12} mt={4}>
                                    KVA Rating *
                                  </Grid>
                                  <FormControl className="selectbox">
                                    <FormGroup className="form-input">
                                      <Select
                                        id="kvaRating"
                                        name="kvaRating"
                                        classes={classes}
                                        options={this.state.kvaRatingOptions}
                                        value={this.state.kvaRating}
                                        onChange={this.handleInputChange(
                                          'kvaRating'
                                        )}
                                        placeholder="KVA Rating"
                                      // error={!this.state.isVehicleModelValid}
                                      />
                                      <FormHelperText
                                        id="name-error-text"
                                        className="Error_msg"
                                      >
                                        {!this.state.isVehicleModelValid
                                          ? 'Invalid Vehicle Model'
                                          : ''}
                                      </FormHelperText>
                                    </FormGroup>
                                  </FormControl>
                                </div>
                              )}

                              {this.state.vehicleSegment == 'DG Set' && (
                                <div>
                                  <Grid xs={12} sm={12} mt={4}>
                                    DG Set Type *
                                  </Grid>
                                  <FormControl className="selectbox">
                                    <FormGroup className="form-input">
                                      <Select
                                        id="dgSetType"
                                        name="dgSetType"
                                        classes={classes}
                                        options={this.state.dgSetTypeOptions}
                                        value={this.state.dgSetType}
                                        onChange={this.handleInputChange(
                                          'dgSetType'
                                        )}
                                        placeholder="DG Set Type"
                                      // error={!this.state.isVehicleModelValid}
                                      />
                                      <FormHelperText
                                        id="name-error-text"
                                        className="Error_msg"
                                      >
                                        {!this.state.isVehicleModelValid
                                          ? 'Invalid Vehicle Model'
                                          : ''}
                                      </FormHelperText>
                                    </FormGroup>
                                  </FormControl>
                                </div>
                              )}



                              {this.state.vehicleSegment == 'DG Set' && (
                                <div>
                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '15px' }}
                                  >
                                    <FormGroup className="form-input">
                                      Manufacturing Year
                                      <Select
                                        options={
                                          this.state.manufacturingYearOptions
                                        }
                                        value={this.state.manufacturingYear}
                                        onChange={this.handleInputChangeNew(
                                          'manufacturingYear'
                                        )}
                                        placeholder="Manufacturing Year"
                                        name="manufacturingYear"
                                        disabled={
                                          this.state.manufacturingYearFromApi
                                        }
                                      />
                                    </FormGroup>
                                  </FormControl>
                                </div>
                              )}




                              {this.state.vehicleSegment == 'DG Set' && (
                                <div>
                                  <Grid
                                    xs={12}
                                    sm={12}
                                    style={{ marginTop: '5px' }}
                                  >
                                    Fuel Type:
                                  </Grid>
                                  <FormControl
                                    className="selectbox"
                                    style={{ marginTop: '5px' }}
                                  >
                                    <FormGroup className="form-input">

                                      {/* {this.state.vehicleSegment === 'DG Set' &&  */}
                                      <Select
                                        id="rcFuelDesc"
                                        name="rcFuelDesc"
                                        classes={classes}
                                        options={[
                                          { value: 'petrol', label: 'PETROL' },
                                          { value: 'diesel', label: 'DIESEL' }
                                        ]}
                                        // components={components}
                                        //value={this.state.fuelType}
                                        value={
                                          this.state.vehicleData
                                            ? this.state.vehicleData.rcFuelDesc
                                            : this.state.rcFuelDesc
                                        }
                                        onChange={selectedOption => {
                                          this.setState({
                                            rcFuelDesc: selectedOption
                                              ? selectedOption.value
                                              : ''
                                          })
                                        }}
                                        placeholder="Fuel Type"
                                      //disabled={this.state.fuelTypeFromApi}
                                      />
                                      {/* } */}
                                    </FormGroup>
                                  </FormControl>
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        {/* end of auto fill section  */}

                        {/* end of vehicke segment section  */}
                      </Grid>

                      <Grid container fullwidth>
                        <FormControl
                          className="selectbox"
                          style={{ marginTop: '10px' }}
                        >
                          <FormGroup className="form-input">
                            <InputLabel
                              htmlFor="vehicleNickName"
                              style={{ marginTop: '-10px' }}
                              shrink={
                                this.state.vehicleNickName ||
                                ((this.state.vehicleData &&
                                  this.state.vehicleData.rcRegnNo) ||
                                  this.state.rcRegnNo)
                              }
                            >
                              Vehicle Name/Number to be displayed on vehicle
                              card (ex. Hyva Truck 08)
                            </InputLabel>
                            <TextField
                              id="vehicleNickName"
                              name="vehicleNickName"
                              className="textfield"
                              margin="dense"
                              type="text"
                              value={
                                this.state.vehicleNickName ||
                                ((this.state.vehicleData &&
                                  this.state.vehicleData.rcRegnNo) ||
                                  this.state.rcRegnNo)
                              }
                              onChange={this.handleInputChange(
                                'vehicleNickName'
                              )}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                    </React.Fragment>
                  )}

                  {this.state.activeStep === 1 && (
                    <VehicleInfoStep
                      state={this.state}
                      classes={classes}
                      client={this.props.client}
                      setState={this.setState.bind(this)}
                      handleInputChange={this.handleInputChange}
                      checkVlpnValidity={this.checkVlpnValidity}
                      handleChangeSpeedSensor={this.handleChangeSpeedSensor}
                      checkSpeedSensorValidity={this.checkSpeedSensorValidity}
                      checkSpeedLimitValidity={this.checkSpeedLimitValidity}
                      timezoneOptions={this.state.timezoneList}
                      handleChangeTimezone={this.handleChangeTimezone}
                      handleFileChange={this.handleFileChange}
                      documentUploadNewData={this.state.documentUploadNewData}
                      handleDocumentUploadNewDataChange={this.handleDocumentUploadNewDataChange}
                      handleDownload={this.handleDownload}
                      handleRemove={this.handleRemove}
                      handleDateChange={this.handleDateChange}
                      handleChangeIdlingSpeed={this.handleChangeIdlingSpeed}
                      handleChangeInputParameter={
                        this.handleChangeInputParameter
                      }
                      handleChangeMultiplicationFactor={
                        this.handleChangeMultiplicationFactor
                      }
                      handleChangeDevice={this.handleChangeDevice}
                      handleChangePhoneNumber={this.handleChangePhoneNumber}
                      handleChangeAccessories={this.handleChangeAccessories}
                      handleTechnicianCategoryChange={
                        this.handleTechnicianCategoryChange
                      }
                      handleTaabiSelectChange={this.handleTaabiSelectChange}
                      handleFreelancerSelectChange={
                        this.handleFreelancerSelectChange
                      }
                      handleChangeSubscription={this.handleChangeSubscription}
                      checkItemValidity={this.checkItemValidity}
                      handleChangeMake={this.handleChangeMake}
                      handleChangeModelNew={this.handleChangeModelNew}
                      checkDualEngineVoltageValidity={
                        this.checkDualEngineVoltageValidity
                      }
                      checkAdblueCapacityValidity={
                        this.checkAdblueCapacityValidity
                      }
                      checkBaselineDataForFEValidity={
                        this.checkBaselineDataForFEValidity
                      }
                      checkBaselineDistanceValidity={
                        this.checkBaselineDistanceValidity
                      }
                      checkBaselineHoursValidity={
                        this.checkBaselineHoursValidity
                      }
                      handleVideoTelematicsMenuChange={
                        this.handleVideoTelematicsMenuChange
                      }
                      handleVtidChange={this.handleVtidChange}
                      handleVideoTelematicsIdChange={
                        this.handleVideoTelematicsIdChange
                      }
                    />
                  )}

                  {this.state.activeStep === 2 && (
                    <InstallationSubmissionStep
                      state={this.state}
                      classes={classes}
                      handleChange={this.handleChange}
                      handleImmobilizeChange={this.handleImmobilizeChange}
                      handleInputChange={this.handleInputChange}
                    />
                  )}
                  <Grid
                    container
                    justify="center"
                    spacing={2}
                    style={{ marginTop: '20px', marginBottom: '20px' }}
                  >
                    {this.state.activeStep > 0 && (
                      <Button
                        variant="outlined"
                        color="primary"
                        className="btn"
                        onClick={this.handleBack}
                      >
                        Back
                      </Button>
                    )}
                    {this.state.activeStep < 2 && (
                      <Tooltip
                        title={
                          (this.state.activeStep === 0
                            ? this.getStep0MissingFields()
                            : this.getStep1MissingFields()
                          ).join(', ') || ''
                        }
                        disableHoverListener={
                          !(this.state.activeStep === 0
                            ? this.isStep0Invalid()
                            : this.isStep1Invalid())
                        }
                      >
                        <span style={{ cursor: 'not-allowed' }}>
                          <Button
                            variant="contained"
                            color="primary"
                            className="btn"
                            onClick={this.handleNext}
                            disabled={
                              this.state.activeStep === 0
                                ? this.isStep0Invalid()
                                : this.isStep1Invalid()
                            }
                          >
                            Next
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                    {this.state.activeStep === 2 && (
                      <Tooltip
                        title={this.getSubmitMissingFields().join(', ') || ''}
                        disableHoverListener={!this.isSubmitFormInvalid()}
                      >
                        <span style={{ cursor: 'not-allowed' }}>
                          <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            margin="normal"
                            className="btn"
                            type="button"
                            onClick={() => {
                              if (
                                this.state.solution_type &&
                                this.state.solution_type.includes('vt') &&
                                !this.state.videoTelematicsId
                              ) {
                                this.setState({
                                  vtValidationError:
                                    'Please select a Video Telematics ID before submitting.'
                                })
                                return
                              }
                              this.setState({ vtValidationError: null })
                              this.handleOpenPreviewModal(true)
                            }}
                            disabled={this.isSubmitFormInvalid()}
                          >
                            Submit
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                    <Button
                      color="default"
                      variant="outlined"
                      size="medium"
                      margin="normal"
                      className="btn"
                      onClick={() => this.props.history.goBack()}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <FormGroup className="form-input">
                    {this.state.vtValidationError && (
                      <p
                        style={{
                          color: 'red',
                          textAlign: 'center',
                          marginBottom: '8px',
                          fontWeight: 500
                        }}
                      >
                        {this.state.vtValidationError}
                      </p>
                    )}
                  </FormGroup>
                </Grid>
              </div>
            </form>
            {/* </ItemCard> */}
          </Grid>
        </Grid>
        <VehiclePreviewModal
          open={this.state.previewModalOpen}
          onClose={this.handleClosePreviewModal}
          vehicleData={this.state.previewData}
          hasSecondaryTank={this.state.hasSecondaryTank}
          calibrationLoading={this.state.calibrationLoading}
          calibrationError={this.state.calibrationError}
          availableDataTypes={this.state.availableDataTypes}
          preferedDataType={this.state.preferedDataType}
          isDualSensor={this.state.isDualSensor}
          hasInSameTank={this.state.hasInSameTank}
          calibrationFilename={this.state.calibration_filename}
          fuelSensorType={this.state.fuelSensorType}
          onConfirm={mutationInput => {
            this.handleSubmit(this.props.client, mutationInput)({
              preventDefault: () => { }
            })
            this.setState({ previewModalOpen: false })
          }}
        />
      </div>
    )
  }
}
VehicleRegistration.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withApollo(withSharedSnackbar(VehicleRegistration))


// WEBPACK FOOTER //
// ./src/components/Modules/VehicleRegistartion/index.jsx